import { RcFile } from 'antd/lib/upload'
import { TableRes } from '../global'
import { MaterialFilesType } from '../modules/goodsdetailmodules/uploadfiles'
import request from '../tools/request'
import { ResultState } from '../tools/public'
import { AccountStatusKey, accountOpenInvoiceStateKey } from '../tools/state'
import { GetLocalStorage, getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
const { GET, POST, downFilePost, uploadFilePOST, downFileGET, DELETE } = request

// 订单管理模块api
// 订单履约模块
/**
 * 获取订单状态及其个数
 * @param params
 * @returns
 */
export const GET_ORDER_STATE_COUNT = (params: { supplierId: string }) =>
  GET(`${HTTP}/order/getOrderStateAndCount`, params)

export type OrderPageRes = {
  accountNo: string
  accountOpenInvoiceStatus: string
  accountStatus: string
  address: string
  consignee: string
  createTime: string
  customer: string
  customerInvoice: string
  customerReturnProgress: string
  id: string
  invoicingState: string
  logisticsNum: string
  mobile: string
  orderNo: string
  orderState: string
  paymentStatus: string
  platform: string
  price: number
  progress: string
  redSport: boolean
  signVoucherState: string
  title: string
  type: string
  dispatchTime: number
  shipmentOverdueTime: number
  properOverdueTime: number
  shipmentOverdue: boolean
  properOverdue: boolean
  shipmentOverdueDesc: string
  properOverdueDesc: string
  shipmentFeedbackList?: OverdueFeedbackItem[]
  properFeedbackList?: OverdueFeedbackItem[]
}

export type OverdueFeedbackAttachment = {
  fileName: string
  fileUrl: string
}

export type OverdueFeedbackItem = {
  feedbackType: '1' | '2'
  expectFinishTime: string
  createTime: string
  reason: string
  attachments?: OverdueFeedbackAttachment[]
}

export type OrderPageParam = {
  address?: string // 收货地址
  consignee?: string // 收件人
  customer?: string // 客户名称
  endDate?: string // 下单日期(截止)
  invoicingState?: string // 开票状态(1--已开票,2--未开票)
  mobile?: string //	联系方式
  orderNo?: string //	客户订单号
  orderPageState?: string // 订单页签状态(空 全部 1--待履约,2--履约中,3--待验收,4-已完成 0-已完成和已结束)
  orderState?: string
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  salesReturnState?: boolean
  schemeId?: string //	方案id
  startDate?: string //	下单日期(起始
  // supplierId: string //供应商id
  accountStatus?: string // 对账状态
  accountOpenInvoiceStatus?: string // 对账开票状态
  cancelState?: boolean
  positiveActualAmountOnly?: boolean
  materialCode?: string
  productName?: string
  brand?: string
  /** 超期类型筛选，多值逗号拼接；订单超期 tab(numMap=5) 默认 1,2 */
  overdueType?: string
  // userId: string // 用户id
}

export type ExportZipParams = OrderPageParam & {
  ids: string[]
}
/**
 * 分页获取订单信息
 * @param params
 * @returns
 */
export const GET_ORDER_PAGE = (params: OrderPageParam) =>
  GET<TableRes<OrderPageRes>>(`${HTTP}/order/getOrderPage`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

export type SuppplierOrderParam = {
  directShipment?: string // 是否厂家直发
  endTime?: string // 结束时间
  groupName?: string // 采购组织
  supplierOrderState?: string // 订单页签状态(0--完成,1--待履约,2--履约中,3--待验收)
  scpShipStatus?: string // scp发货状态 WAIT-待发货，COMPLETE-已完成
  orderState?: string
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  receiveMan?: string // 收件人
  schemeId?: string //	方案id
  stateTime?: string // 开始时间
  // supplierId: string //供应商id
  // userId: string // 用户id
  confirmState?: boolean // 是否待确认
  cancelState?: boolean // 是否有取消
  returnState?: boolean // 是否有退货
  refuseState?: boolean // 是否拒单
  materialCode?: string
  productName?: string
  brand?: string
  supplierOpenInvoiceState?: string // 供应商开票状态
}

/**
 * 分页获取供应商订单接口
 * @param params
 * @returns
 */
export const GET_SUPPLIER_ORDER_PAGE = (params: SuppplierOrderParam) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderPage`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

// 供应商信息
export const GET_TAB_SUPPLIER_ORDERCOUNT = (params: SuppplierOrderParam) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderCount`, params)

export type AcceptInfoItem = {
  acceptList: { baseUrl: string; id: string; name: string; url: string }[]
  createTime: number | string
  id: string
  type: string
  uploadMan: string
  auditMan: string
  auditState: string // 审核状态
  groundsForRejection: string // 驳回理由
}

export type ProductList = {
  brand: string
  cancelCount: number
  code: string
  delCount: number
  id: string
  imgUrl: string // 商品图片地址
  isDisabled: boolean
  /** 有值表示转派，前端用于禁用行勾选 */
  transferSupplierName?: string
  model: string
  name: string
  num: number
  price: number
  progress: string
  reCount: number
  salePrice: number // 销售单价
  unCount: number
  unit: string
  rowId?: string
  costPriceTaxRate?: string
  orderNo?: string
  systemCategoryCode?: string
}

export type OrderDteailRes = {
  paymentMethodList: string[]
  cancelPrice: string
  acceptInfoDTOS: AcceptInfoItem[]
  accountNo: string
  accountId: string
  accountStatus: string
  accountOpenInvoiceStatus: string
  address: string
  allShipTime: number
  checkState: string
  confirmVoucherTime: number
  consignee: string
  createTime: string
  customer: string
  returnState: string
  firstShipTime: number
  id: string
  supplierOrderId?: string
  invoicingState: string
  mobile: string
  orderNo: string
  orderState: string
  orderPaymentId: string
  platform: string
  platformCode: string
  orderTransferSupported: boolean
  price: number
  progress: string
  refundPrice: number
  settlePrice: number
  paymentStatus: string
  remark: string
  signVoucherState?: string
  invoiceApplicationNum: string
  orderInvoiceId: string
  prohibitionPaymentState: boolean
  dispatchTime: number
  titleOfTheContract?: string
  acceptAuditState?: string
  acceptAuditMan?: string
  acceptGroundsForRejection?: string
  purchaseOrderContract?: any
  customerInfoAttachments?: any
  orderRemark?: string
  shipmentOverdueTime?: number
  properOverdueTime?: number
  shipmentOverdue?: boolean
  properOverdue?: boolean
  shipmentOverdueDesc?: string
  properOverdueDesc?: string
}
/**
 * 获取订单详情
 * @param params 订单id
 * @returns
 */
export const GET_ORDER_DETAIL = (params: { orderId: string }) =>
  GET<OrderDteailRes>(`${HTTP}/order/getOrderDetail`, params)

export type ListDetail = {
  cancelInfoVO: any
  returnInfoVO: {
    erpNo: string // erp采购退料单号
    returnDetailList: {
      brand: string
      manuCode: string
      productCode: string
      productName: string
      productPrice: number
      returnNum: number
      unit: string
    }[]
    returnNo: string
    returnId: string
    returnPrice: number
    returnTime: number
    state: string
  }[]
  productDetailVO: ProductList[]
  deliveryDetailVO: {
    deliveryProductList: {
      brand: string
      code: string
      delCount: number
      id: string
      model: string
      name: string
      num: number
      price: number
      unit: string
    }[]
    deliveryTime: string
    expressCompany: string
    expressNo: string
    id: string
    state: string
  }[]
}
// 获取订单详情明细表格数据
export const GET_ORDER_PRODUCT_INFO = (params: { orderId: string }) =>
  GET<ListDetail>(`${HTTP}/order/getOrderProductInfo`, params)

interface DataInfoItem {
  fileIdList: string[]
  id: string // 签收单信息 id
  type: string
}

export const SUBMIT_ORDER_ACCEPT = (params: {
  dataInfo: DataInfoItem[]
  orderId: string // 订单 id
  // uploadMan: string
}) =>
  POST(
    `${HTTP}/order/submitOrderAccept`,
    {
      ...params,
      uploadMan: getUserId(),
    },
    'application/json',
  )

export const DOWNLOAD_PURCHASEORDERCONTRACT = (params: { orderId: string }) =>
  downFilePost(
    `${HTTP}/order/downloadPurchaseOrderContract?orderId=${params.orderId}`,
  )

export const DOWNLOAD_SUPPLIERORDERCONTRACT = (params: { orderId: string }) =>
  downFilePost(
    `${HTTP}/supplierOrder/downloadPurchaseOrderContract?orderId=${params.orderId}`,
  )
export interface DetailedProductDTOList {
  brand: string
  cancelQty: number
  detailId: string
  id: string
  mainPicture?: string | null
  isDisabled: boolean
  manuCode: string
  num: number
  productCode: string
  productName: string
  productPrice: number
  returnQty: number
  settleQty: number
  shipQty: number
  stockInputQty: number
  stockOutputQty: number
  unit: string
  unitDigit: number
  waitQty: number
  progress?: any
}
export type SignVoucherFileItem = {
  id: string
  url: string
  baseUrl: string
  name: string
  type: string
}

export type SignVoucherUploadFileItem = {
  filename: string
  newFilePath: string
  newFileName?: string
  fileRes?: string
  baseUrl?: string
  type?: string
  relationType?: string
}

export type DirectedSignVoucher = {
  signVoucherState?: string
  signVoucherRejectReason?: string
  signVoucherTime?: string
  signVoucherFiles?: SignVoucherFileItem[]
}

export type SupplierOrderDetailRes = {
  cancelReturnPrice: number
  code: string
  detailedProductDTOList: DetailedProductDTOList[]
  directShipment: boolean
  finalPrice: Record<string, unknown>
  groupName: string
  id: string
  orderCreateTime: string
  orderState: string
  orderStateToName: string
  price: string
  purchaseGroupName: string
  purchaseMan: string
  receiveAddress: string
  receiveMan: string
  receiveMobile: string
  warehousingProgress: string
  customerOrderCode: string
  scpShipStatusName: string
  scpShipStatus: string
  orderType?: string
  signVoucherFiles?: SignVoucherFileItem[]
  signVoucherState?: string
  signVoucherRejectReason?: string
  signVoucherTime?: string
  allShipped?: boolean
  directedApplyNo?: string
  directedSignVoucher?: DirectedSignVoucher
}

/**
 * 获取供应商订单详情
 * @param params 订单id
 * @returns
 */
export const GET_SUPPLINER_ORDER_DETAIL = (params: { id: string }) =>
  GET<SupplierOrderDetailRes>(`${HTTP}/supplierOrder/getSupplierOrder`, params)

/**
 * 上传签收凭证
 */
export const UPLOAD_SIGN_VOUCHER = (params: {
  orderId: string
  fileList: SignVoucherUploadFileItem[]
}) =>
  POST(`${HTTP}/supplierOrder/uploadSignVoucher`, params, 'application/json')

/**
 * 删除签收凭证
 */
export const DELETE_SIGN_VOUCHER = (params: { id: string }) =>
  POST(`${HTTP}/supplierOrder/deleteSignVoucher`, params, 'application/json')

/**
 * 获取供应商发货单明细
 * @param params 订单id
 * @returns
 */
export const GET_SUPPLINER_ORDER_SHIP = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderShipById`, params)

/**
 * 获取供应商退货单明细
 * @param params 订单id
 * @returns
 */
export const GET_SUPPLINER_ORDER_RETURN = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderReturnById`, params)

/**
 * 获取供应商取消单明细
 * @param params 订单id
 * @returns
 */
export const GET_SUPPLINER_ORDER_CANCEL = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderCancelById`, params)

/**
 * 下载验收单模板
 * @returns
 */
export const DOWNLOAD_ACCEPT_TEMP = (params: { id: string }) =>
  downFilePost(`${HTTP}/order/downloadAcceptTemp`, params)

/**
 * 下载客户定制验收单模板
 * @param params 订单id
 * @returns
 */
export const DOWNLOAD_CUSTOM_ACCEPT_TEMP = (params: { id: string }) =>
  downFilePost(`${HTTP}/order/downloadAcceptTemp2`, params)

export const DOWNLOAD_ZIP_MORE = (params: { fileIdList: string[] }) =>
  downFilePost(`${HTTP}/upload/downloadZipMoreFile`, params)

/**
 * 确认订单
 * @returns
 */
export const CONFIRM_ORDER = (params: { id: string }) =>
  POST(`${HTTP}/supplierOrder/confirmOrder`, params, 'application/json')

export interface MSGPARAMS {
  supplierId?: string
  type?: string
  userId?: string
  schemeId?: string
  content?: string
  pageNo: number
  pageSize: number
  readState?: boolean
}
/**
 * 获取消息列表
 * @param MSGPARAMS
 * @returns
 */
export const GET_MESSAGE_LIST = (params: MSGPARAMS) =>
  GET<TableRes<NoticeItemRes>>(`${HTTP}/noticeCenter/getPage`, params)

export type NoticeItemRes = {
  content: string
  id: string
  isRead: boolean
  time: string
  type: string
  typeToName: string
  title?: string
}
export const GET_MESSAGE_LIST_PAGE = (params: MSGPARAMS) =>
  GET<TableRes<NoticeItemRes>>(`${HTTP}/noticeCenter/getPage`, {
    supplierId: getSupplierId(),
    userId: getUserId(),
    ...params,
  })

export type MessageItem = {
  content: string
  id: string
  isRead: boolean
  time: string
  type: string
  typeToName: string
}

/**
 * 获取消息列表
 * @param MSGPARAMS
 * @returns
 */
export const GET_MESSAGE_SIZE_LIST = (params: {
  supplierId: string
  size?: number
}) => GET<MessageItem[]>(`${HTTP}/noticeCenter/getNoticeCenterList`, params)

export type MessageDetailRes = {
  content: string
  id: string
  supplierOrderId: string
}

/**
 * 获取消息详情
 * @param id
 * @returns
 */
export const GET_MESSAGE_DETAIL = (params: { id: string }) =>
  GET<MessageDetailRes>(`${HTTP}/noticeCenter/get`, params)

interface PRODUCTDATAIL {
  brand?: string // 品牌
  deliveryQty?: string // 本次发货数量
  id?: string //
  manuCode?: string // 规格型号
  productCode?: string // 物料编码
  productName?: string // 商品名称
  productPrice?: string // 单价
  unit?: string // 单位
  unitDigit?: string // 数量
  waitQty?: string // 待发数量
}
/**
 * 新建发货单订单
 * @returns
 */
export const NEW_SUPPLIER_ORDER = (params: {
  id: string
  logisticsCompany: string // 快递公司
  logisticsCode: string // 物流单号
  trackNum: string // 快递编码
  // logisticsCompanyCode: string
  productDetailList: PRODUCTDATAIL[]
  code: string // 快递code
  receiveMan: string // 收货人
  receiveMobile: string // 收货人手机号
  receiveAddress: string // 收货地址
}) =>
  POST(
    `${HTTP}/supplierOrder/supplierOrderDelivery`,
    {
      ...params,
      supplierId: getSupplierId(),
    },
    'application/json',
  )

/**
 * 修改物流公司
 * @returns
 */
export const CHANGE_EXPRESSCOMPANY = (params: {
  id: string
  logisticsCompany: string // 快递公司
  logisticsCode: string
  trackNum: string
  // logisticsCompanyCode: string
}) =>
  POST(`${HTTP}/supplierOrder/updateLogisticsInfo`, params, 'application/json')

/**
 * 确认收货
 * @returns
 */
export const CONFIRM_GOODS = (params: { id: string }) =>
  POST(`${HTTP}/supplierOrder/confirmReceipt`, params, 'application/json')

/**
 * 确认收货
 * @returns
 */
export const ORDER_STORY = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrder/getOrderProgressTime`, params)

/**
 * 导出全部明细
 * @returns
 */
export const EXPORT_ALL_DETAIL = (params: { id: string }) =>
  POST(
    `${HTTP}/supplierOrder/exportSupplierOrderDetails`,
    params,
    'multipart/form-data',
  )

/**
 * 导出配货单
 * @returns
 */
export const EXPORT_ORDER_DETAIL = (params: { orderId: string }) =>
  downFileGET(`${HTTP}/supplierOrder/exportSupplierOrderShipDetails`, params)

// 导出配货单-发货明细列表
export const EXPORT_ORDER_SHIP_DETAIL = (params: { shippingOrderId: string }) =>
  downFileGET(
    `${HTTP}/supplierOrder/exportSupplierOrderShipDetailsByShippingOrderId`,
    params,
  )

export type ExpressCompanyRes = { expressCode: string; expressCompany: string }

/**
 * 获取物流公司选择列表
 * @returns
 */
export const GET_EXPRESSCOMPANY_LIST = (params: {
  type: string // 下单平台
}) => GET<ExpressCompanyRes[]>(`${HTTP}/order/getExpressCompanyList`, params)

/**
 * 获取OMS承运商物流公司列表
 * @returns
 */
export const GET_OMS_EXPRESSCOMPANY_LIST = () =>
  GET<ExpressCompanyRes[]>(`${HTTP}/order/getLogisticsCompany`)

interface Product {
  brand?: string // 品牌
  code?: string // 物料编码
  delCount?: number // 发货数量
  id?: string // 明细id
  model?: string // 型号
  name?: string // 商品名称
  num?: number // 数量
  price?: number // 单价
  reCount?: number // 退货数量
  unCount?: number // 未发数量
  unit?: string // 单位
  rowId?: string // 物料行id
  costPriceTaxRate?: string // 成本价税率
}
/**
 * 新建发货单
 * @returns
 */
export const ORDER_DELIVERY = (params: {
  expressCode: string // 物流公司编码
  expressCompany: string // 物流公司
  expressNo: string // 物流单号
  orderId: string
  productDetailList: Product[]
}) =>
  POST(
    `${HTTP}/order/orderDelivery`,
    { ...params, supplierId: getSupplierId() },
    'application/json',
  )

/**
 * 变更发货单
 * @returns
 */
export const ORDER_DELIVERY_UPDATE = (params: {
  expressCode: string // 物流公司编码
  expressCompany: string // 物流公司
  expressNo: string // 物流单号
  orderId: string // 订单id
  deliveryId: string // 发货单id
  // productDetailList: Product[]
}) => POST(`${HTTP}/order/orderDeliveryUpdate`, params, 'application/json')

type CertificateType =
  | 'account'
  | 'invoice'
  | 'twoOrder'
  | 'orderInvoice' // 电商供应商附件
  | 'orderOtherFile'
  | 'mainPicture' // 主图
  | 'detailsPicture' // 详情图
  | 'contract'
  | 'priceSupportingEvidence' // 价格佐证
  | 'scpImportProduct' // 订单报备 -> 商品报备 -> 导入
  | 'regionalStock' // 导入区域库存
  | MaterialFilesType
  | 'materialAptitude' // 资质图片
  | 'inquiryImportSCP' // 询价单导入SCP
  | 'orderOverdueFeedback'

export const certificateTypeDict: { [key: string]: string } = {
  '1': '两单',
  '2': '咸亨验收单',
}

/**
 * 上传验收单|对账单    对账单上传的时候可以不带code
 * @param params
 * @param file 验收单文件列表  code 订单id
 * @returns
 */
export type uploadType = CertificateType
export const UPLOAD_FILES = (
  params: {
    type?: CertificateType
    code?: string
  },
  file: any,
) =>
  uploadFilePOST(`${HTTP}/upload/uploadFiles`, file, {
    ...params,
    uploadMan: GetLocalStorage('USER_NAME'),
  })

/**
 * 删除附件，文件id在上传验收单的时候接口会返回
 * @param params
 * @returns
 */
export const DETELE_FILE = (params: {
  id: string // 文件id
}) => POST(`${HTTP}/upload/deleteFile`, params, 'application/json')

/**
 * 获取发货单详情
 * @param params 订单id
 * @returns
 */
export const GET_ORDER_DELIVERY_DETAIL = (params: {
  orderDeliveryId: string
}) => GET(`${HTTP}/order/getOrderDeliveryDetail`, params)

/**
 * 获取退货单订单状态及其个数
 * @param params
 * @returns
 */
export const GET_ORDERRETURN_STATECOUNT = (params: { supplierId: string }) =>
  GET(`${HTTP}/return/getOrderReturnStateCount`, params)

export type ReturnManagementParam = {
  address?: string // 收货地址
  consignee?: string // 收件人
  customer?: string // 客户名称
  mobile?: string //	联系方式
  orderNo?: string //	客户订单号
  orderReturnNo?: string // 退货单号
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  returnApplyStartDate?: string
  returnApplyEndDate?: string
  returnCount?: number // 退货数量
  returnPrice?: number // 退货金额
  returnState?: string // 单子状态(0--全部,1--退货申请/取消申请,2--退货中,3--已完结)
  returnType?: string // 单子类型(1--退货单,2--取消单)
  schemeId?: string //	方案id
  // supplierId: string //供应商id
}
/**
 * 分页获取退货单订单信息
 * @param params
 * @returns
 */
export const GET_RETURNORDER_PAGE = (params: ReturnManagementParam) =>
  GET(`${HTTP}/return/getReturnOrderPage`, {
    ...params,
    supplierId: getSupplierId(),
  })

/**
 * 分页获取供应商退货单订单信息
 * @param params
 * @returns
 */
export const GET_SUPPLIER_RETURNORDER_PAGE = (params: {
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  schemeId?: string //	方案id
  supplierId: string // 供应商id
  status?: string
  supplierOrderDirectShipment?: boolean // 是否厂家直发
  supplierOrderReturnCode?: string // 采购订单号
  supplierOrderReturnEndTime?: string // 结束时间
  supplierOrderReturnGroupName?: string // 采购组织
  supplierOrderReturnNum?: string // 件数
  supplierOrderReturnNumber?: string // 单号
  supplierOrderReturnPrice?: string // 金额
  supplierOrderReturnReceiveMan?: string // 采购员
  supplierOrderReturnStartTime?: string // 开始
  supplierOrderReturnType?: string // 单据类型
  userId?: string
}) => GET(`${HTTP}/supplierOrderReturn/getSupplierOrderReturnPage`, params)

export type FillingRes = {
  arriveTime: string
  customer: string
  filingNo: string
  filingTime: string
  filingType: string
  id: string
  orderNo: string
  platform: string
  price: number
  state: string
}

/**
 * 分页获取报备单信息
 * @param params
 * @returns
 */
export const GET_FILING_PAGE = (params: {
  customer?: string // 客户名称
  filingArriveEndTime?: string // 到期日(截止)
  filingArriveStartTime?: string // 到期日(起始)
  filingEndTime?: string // 报备日期(截止)
  filingNo?: string //	报备单号
  filingOrderEndTime?: string // 预计点单日(截止)
  filingOrderStartTime?: string // 预计点单日(起始)
  filingStartTime?: string // 报备日期(起始)
  fillingState?: string // 报备单状态(1--报备中,2--已派单,3--已撤回)
  num?: number // 报备数量
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  price?: number // 退货金额
  schemeId?: string //	方案id
  supplierId: string // 供应商id
  supplierUserId: string // 用户id
}) => GET<TableRes<FillingRes>>(`${HTTP}/filing/getFilingPage`, params)

/**
 * 分页获取对账单信息
 * @param params
 * @returns
 */
export const GET_ACCOUNT_PAGE = (params: {
  accountEndTime?: string // 提交日期(截止)
  accountNo?: string // 对账单号
  accountStartTime?: string // 提交日期(起始)
  accountState?: string // 对账单状态(1--待确认,2--已确认,3--已部分回款,4--已回款,5--已作废)
  accountOpenInvoiceStatus?: string // 供应商开票(1--未开票,2--已开票)
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  price?: number // 对账金额
  returnPrice?: number // 已回金额
  schemeId?: string //	方案id
  supplierId: string // 供应商id
}) => GET(`${HTTP}/supplier/invoice/getAccountPage`, params)

interface FileList {
  baseUrl: string
  id: string
  name: string
  url: string
}
interface ProductInfoList {
  brandName: string
  model: string
  orderNo: string
  productCode: string
  productCount: number
  productId: string
  productName: string
  productPrice: number
  unit: string
}
export interface OrderInfoList {
  customer: string
  customerPayback: string
  finalPrice: number
  orderId: string
  orderInvoiceStatus: string
  orderNo: string
  orderPrice: number
  orderTime: number
  platform: string
  signVoucherState: string
}
export interface OrderAccountInvoiceInfoList {
  accountInvoiceId: string
  fileList: FileList[]
  invoiceCode: string
  invoiceNum: string
  invoiceTime: number
  logisticsCompany: string
  logisticsNum: string
  price: number
}
export interface AccountDetailRes {
  accountNo: string
  accountOpenInvoiceStatus: accountOpenInvoiceStateKey
  accountPrice: number
  accountStatus: AccountStatusKey
  commitTime: string
  confirmMan: string
  confirmTime: string
  createSupplier: string
  createTime: string
  id: string
  orderAccountInvoiceInfoList: OrderAccountInvoiceInfoList[]
  orderInfoList: OrderInfoList[]
  productInfoList: ProductInfoList[]
  supplierRemark: string
  groundsForRejection: string
}

/**
 * 获取对账单详情
 * @param
 * @returns
 */
export const GET_ACCOUNT_DETAIL = (params: { accountId: string }) =>
  GET<AccountDetailRes>(`${HTTP}/input/invoice/getAccountDetail`, params)

interface InvoiceInfoParams {
  accountInvoiceId?: string
  fileIds: string[]
  invoiceCode: string
  invoiceNum: string
  invoiceTime: number
  logisticsCompany: string
  logisticsNum: string
  price: number
}
interface CommitAccountParams {
  addInvoiceInfoParams: InvoiceInfoParams[]
  id?: string // 对账单id(修改传入)
  orderList?: any[] // 订单明细
  type?: string // 提交类型(1--提交开票,2--暂存)
}

/**
 * 获取已验收订单信息
 * @param params
 * @returns
 */
export const GET_DONE_ORDER_LIST = (params: {
  consignee?: string // 收件人
  customer?: string //	客户名称
  orderEndTime?: string // 下单时间(截止)
  mobile?: string // 联系方式
  orderNo?: string //	客户订单号
  platform?: string // 下单平台
  settlePrice?: string //	最终结算金额
  orderStartTime?: string // 下单时间(开始)
  supplierId: string // 供应商id
}) => GET(`${HTTP}/supplier/invoice/getDoneOrderList`, params)

interface UpdateAccountParams extends CommitAccountParams {
  detailIds: string[] // 删除的订单列表
}

/**
 *更新对账单
 * @returns
 */
export const UPDATE_ACCOUNT = (params: UpdateAccountParams) =>
  POST(`${HTTP}/supplier/invoice/updateAccount`, params, 'application/json')

type InvoicePageRes = {
  createTime: string
  customer: string
  invoicingState: string
  orderNo: string
  platform: string
  price: number
}

export type InvoicePageParam = {
  createTime?: string // 下单时间
  customer?: string // 下单名称
  invoicingState?: string // 开票状态
  logisticsNum?: string // 物流单号
  orderNo?: string // 客户订单号
  platform?: string // 下单平台
  price?: string // 下单金额
  title?: string // 发票抬头
  type?: string // 发票类型
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
}
/**
 * 获取开票申请列表
 * @param params
 * @returns
 */
export const GET_INVOICABLE_PAGE = (params: InvoicePageParam) =>
  GET<TableRes<InvoicePageRes>>(`${HTTP}/order/getOrderInvoicablePage`, {
    ...params,
    supplierId: getSupplierId(),
  })

export type OrderInvoiceParams = {
  address: string // 地址
  bankAccount: string // 银行账号
  bankName: string // 开户银行
  content: string // 票面描述
  mobile: string // 电话
  orderInvoiceEnums: string // 发票类型
  receiveAddress: string // 收件人地址
  receiveMan: string // 收件人
  receiveMobile: string // 收件人联系电话
  remark: string // 其它备注
  taxNumber: string // 税号
  title: string // 发票抬头
}
/**
 * 提交开票申请
 * @param params
 * @returns
 */
export const SUBMIT_ORDER_INVOICE = (
  params: { orderId: string; fileIdList?: string[] } & OrderInvoiceParams,
) =>
  POST(
    `${HTTP}/order/submitOrderInvoice`,
    { ...params, supplierId: getSupplierId() },
    'application/json',
  )

// 获取发票申请详情
export const GET_ORDER_INVOICE_DETAIL = (params: { orderInvoiceId: string }) =>
  GET(`${HTTP}/order/orderInvoiceApplyInfo`, params)

export interface OrderInvoicingParams {
  createTime?: string // 下单时间
  customer?: string // 客户名称
  invoicingState?: string // 开票状态
  logisticsNum?: string // 物流单号
  orderNo?: string // 客户订单号
  platform?: string // 下单平台
  price?: string // 下单金额
  title?: string // 发票抬头
  type?: string // 发票类型
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  supplierId?: string
}

// 获取开票申请订单
export const GET_ORDER_INVOICING_PAGE = (params: OrderInvoicingParams) =>
  GET(`${HTTP}/order/getOrderInvoicingRequisitionPage`, {
    ...params,
    supplierId: getSupplierId(),
  })

// 根据订单id下载发票
export const POST_DOWNLOAD_INVOICE_ZIP = (params: { orderId: string }) =>
  downFilePost(
    `${HTTP}/order/downloadInvoiceZipByOrderId?orderId=${params.orderId}`,
  )

// 根据开票类型获取对应的数量
export const GET_INVOICE_COUNT = (params: { type: string }) =>
  GET(`${HTTP}/order/getInvoiceCountByType`, {
    ...params,
    supplierId: getSupplierId(),
  })

export type SupplierCountRes = {
  cancellationOrderCount: number
  invoiceCount: number
  returnOrderCount: number
}

export const GET_SUPPLIER_COUNT = (params: {
  supplierOrderId: string // 采购单id
}) =>
  GET<SupplierCountRes>(
    `${HTTP}/supplierOrderReturn/getSupplierOrderCount`,
    params,
  )

export type AllowAccountRes = {
  titleOfTheContract?: string
  customer: string
  customerInvoice: string
  finalPrice: number
  id: string
  orderNo: string
  orderPrice: number
  orderState: string
  orderTime: number
  platform: string
  platformCode: string
  receiveMan: string
  returnState: string
  signVoucherState: string
  isDisabled: boolean // 是否为不可勾选
  type?: 'new' | 'origin'
  code?: string
}

export interface ReconcilableParams {
  accountStatus?: string
  customer?: string
  orderNo?: string
  pageNo?: number
  pageSize?: number
  platform?: string
  schemeid?: string
  excludeOrderIds?: string // 被排除的订单Id集合
  supplierOrderCode?: string
  receiveMan?: string
}

export const GET_ALLOW_ACCOUNT_PAGE = (params: ReconcilableParams) =>
  GET<TableRes<AllowAccountRes>>(`${HTTP}/input/invoice/order/page`, {
    ...params,
    supplierUserId: getUserId(),
  })

interface BatchAccountParam {
  id?: string // 对账单id，修改对账单时传入
  orderIds: string[]
  price: number | string
  remark?: string
}

export const BATCH_ACCOUNT = (params: BatchAccountParam) =>
  POST(
    `${HTTP}/supplier/invoice/batchAccount`,
    {
      ...params,
      userId: getUserId(),
      supplierId: getSupplierId(),
      supplierName: GetLocalStorage('HOME_DATA')?.enterpriseName,
    },
    'application/json',
  )

export type InvoiceParams = {
  fileIdList: string[]
  fileList: { baseUrl: string; id: string; name: string; url: string }[]
  invoiceCode: string
  invoiceNum: string
  invoiceTime: number
  logisticsCompany: string
  logisticsNum: string
  price: number
  invoiceId: string
}

export type AccountOpenInvoiceParam = {
  invoiceParams: InvoiceParams[]
  deletedIds?: string[]
  deletedFileIds?: string[]
  orderAccountId: string
  supplierId?: string
}
/**
 * 对账单开票
 * @param params
 * @returns
 */
export const ACCOUNT_OPEN_INVOICE = (params: AccountOpenInvoiceParam) =>
  POST(
    `${HTTP}/input/invoice/accountOpenInvoice`,
    {
      ...params,
      supplierId: getSupplierId(),
    },
    'application/json',
  )

// 批量获取订单详情
export const GET_BATCH_ORDER_DETAIL = (params: { orderId: string }) =>
  GET<OrderDteailRes[]>(`${HTTP}/order/batchOrderDetail`, params)

export interface BatchProductInfo extends ListDetail {
  orderNo: string
  orderId: string
}
// 批量获取订单详情明细表格数据
export const BATCH_GET_ORDER_PRODUCT_INFO = (params: { orderIds: string }) =>
  GET<BatchProductInfo[]>(`${HTTP}/order/batchGetOrderProductInfo`, params)

// 订单合并开票申请
export const POST_BATCH_SUBMIT_ORDER_INVOICE = (
  params: {
    orderIds: string[]
    orderInvoiceFileDTOS?: {
      uploadMan: string
      url: string
    }[]
  } & OrderInvoiceParams,
) =>
  POST(
    `${HTTP}/order/batchSubmitOrderInvoice`,
    { ...params, supplierId: getSupplierId() },
    'application/json',
  )

// 根据开票申请单号获取关联订单详情
export const GET_ORDER_DETAIL_BY_APPLICATION_NUM = (params: {
  applicationNumber: string
}) =>
  GET<OrderDteailRes[]>(`${HTTP}/order/orderDetailsByApplicationNum`, params)

export type OverdueFeedbackUploadedFile = {
  name: string
  url: string
  baseUrl?: string
}

export const UPLOAD_FILES_NO_SAVE = (
  params: {
    type?: CertificateType
    code?: string
  },
  file: any,
) =>
  uploadFilePOST(`${HTTP}/upload/uploadFilesNoSave`, file, {
    ...params,
    uploadMan: GetLocalStorage('USER_NAME'),
  })

export const UPLOAD_OVERDUE_FEEDBACK_FILE = (
  params: { code?: string },
  file: RcFile,
) =>
  UPLOAD_FILES_NO_SAVE(
    { ...params, type: 'orderOverdueFeedback' },
    file,
  ) as Promise<ResultState<OverdueFeedbackUploadedFile[]>>

export type OverdueFeedbackSubmitParam = {
  orderId: string
  feedbackType: '1' | '2'
  expectFinishTime: string
  reason: string
  attachments: Array<{ name: string; url: string }>
}

export const SUBMIT_OVERDUE_FEEDBACK = (params: OverdueFeedbackSubmitParam) =>
  POST<boolean>(
    `${HTTP}/order/submitOverdueFeedback`,
    params,
    'application/json',
  )

export type InvoiceInfoRes = {
  bankAccount: string
  bankName: string
  invoiceAddress: string
  invoiceFaceInfo: string
  invoiceTitle: string
  invoiceType: string
  invoiceTypeStr: string
  mobile: string
  openInvoiceMobile: string
  receiveAddress: string
  receiveMan: string
  taxCode: string
}

export type InvoiceInfoParam = {
  orderId: string
}
/**
 * 根据订单 id 获取详情发票信息
 * @param params
 * @returns
 */
export const GET_INVOICE_INFO_BY_ID = (params: InvoiceInfoParam) =>
  GET<InvoiceInfoRes>(`${HTTP}/order/getOrderDetailInvoiceByOrderId`, params)

export interface RecognizeInvoiceParams {
  url: string
  fileId?: string
}

export interface RecognizeInvoiceRes {
  baseUrl: string
  invoiceCode: string
  invoiceNum: string
  invoiceTime: string
  totalAmount: string
  totalAmountIncludingTax: string
  totalTaxAmount: string
  url: string
  fileId: string
  invoiceType: {
    descriptions: string
    key: string
  }
  checkCode: string
}

// 批量获取发票代码和发票号
export const POST_RECOGNIZE_INVOICE = (params: { fileUrls: string }) =>
  GET<RecognizeInvoiceRes[]>(`${HTTP}/input/invoice/identify`, params)

// 导出寄票随单
export const POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP = (params: string[]) =>
  downFilePost(`${HTTP}/input/invoice/downloadAcceptTemp`, params)

// 获取工作台-开票付款数据
export const GET_ACCOUNT_PAYMENT_COUNT = (params: { supplierId: string }) =>
  GET(`${HTTP}/input/invoice/data-count`, params)

/**
 * 导出选中货物配货单
 * @returns
 */
export const EXPORT_SELECT_ORDER_DETAIL = (params: {
  directShipment: boolean
  orderId: string
  customerOrderCodes: any
  productCodeList: string[]
  ids: string[]
}) => downFilePost(`${HTTP}/supplierOrder/exportPackingList`, params)

export interface InvoiceEntryParams {
  customer?: string
  excludeOrderIds?: string // 被排除的订单Id集合
  orderNo?: string
  orderTimeStart?: string
  orderTimeEnd?: string
  pageNo?: number
  pageSize?: number
  platform?: string
  receiveMan?: string
  schemeId?: string
  signVoucher?: string
  customerPayback?: string
}

// 新增发票-分页获取电商供应商可开票订单
export const GET_INVOICE_PAYMENT_CANINVOICE = (params: InvoiceEntryParams) =>
  GET(`${HTTP}/input/invoice/order/page`, {
    ...params,
    supplierUserId: getUserId(),
  })

export interface InvoiceVerificationParams {
  invoiceCode: string // 发票代码
  invoiceNum: string // 发票号
  invoiceTime: number // 开票时间
  invoiceType: string // 发票类型
  totalAmount: number // 合计金额
  totalAmountIncludingTax: number // 价税合计
  totalTaxAmount: number // 合计税额
  relationId?: string // 发票单id
  checkCode?: string // 校验码
}

// 发票验真接口
export const INVOICE_VERIFICATION = (params: InvoiceVerificationParams) =>
  POST(`${HTTP}/input/invoice/verification`, params, 'application/json')

export interface InvoiceParamItem {
  file: {
    baseUrl: string
    id: string
    name: string
    url: string
  }
  id: string
  invoiceCode: string
  invoiceNum: string
  invoiceTime: number
  invoiceType: string
  totalAmount: number
  totalAmountIncludingTax: number
  totalTaxAmount: number
  seller?: string
}
export interface saveInvoiceParams {
  relationId: string
  dateState: string // 发票单状态
  deleteInvoiceIds?: string[] // 已删除的发票id
  deleteOrderIds?: string[] // 已删除的订单id
  invoiceParam: InvoiceParamItem[] // 发票列表数据
  orderIds: string[] // 订单id
  supplierId: string
  logisticsCompany: string
  logisticsNum: string
  deleteFileIds?: string[] // 已删除的发票附件id
}

// 保存或暂存电商供应商发票
export const LANDER_SAVE_INVOICE = (params: saveInvoiceParams) =>
  POST(`${HTTP}/input/invoice`, params, 'application/json')

// 保存或暂存供应商发票
export const SUPPLIER_SAVE_INVOICE = (params: saveInvoiceParams) =>
  POST(`${HTTP}/input/invoice/supplierInvoice`, params, 'application/json')

// 我的发票列表数据
export interface MyInvoiceItem {
  titleOfTheContract: any
  id: string
  accountId: string // 旧订单id
  invoiceAmount: number // 发票价税合计
  invoiceNums: string // 发票编号
  invoiceState: string // 1 审核中 2 暂存 3 通过 4 驳回
  orderAmount: number // 订单价税合计
  orderNos: string // 订单编号
  platform: string // 下单平台
  orderCodes: string // 采购订单号
  orderSource: string // 源单类型
  invoiceNature: string
}

/**
 * 分页获取我的发票
 * @param params
 * @returns
 */
export const GET_MY_INVOICE_LIST = (params: {
  schemeId?: string
  pageNo?: number
  pageSize?: number
  invoiceNum?: string
  orderNo?: string
  platform?: string
  invoiceState?: string
  orderSource?: string
  supplierOrderCode?: string
  invoiceNature?: string
  returnOrderNo?: string
}) =>
  GET<TableRes<MyInvoiceItem>>(`${HTTP}/input/invoice/relation/page`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

interface orderItem {
  orderTime: number // 下单时间
  customer: string // 客户名称
  customerReturnProgress: string // 回款进度 0-未回款 1-部分回款 2-全部回款
  id: string // 订单id
  orderNo: string // 客户订单号
  platform: string // 下单平台
  signVoucherState: string // 签收凭证
  totalAmount: number // 合计金额
  totalAmountIncludingTax: number // 价税合计
  totalTaxAmount: number // 合计税额
}

/**
 * ReturnOrderDetailVo
 */
export interface ReturnOrderDetailVo {
  /**
   * ERP 采购退料单号
   */
  erpNo?: string
  /**
   * 采购订单号
   */
  erpOrderNo?: string
  /**
   * 订单所属ERP
   */
  erpType?: string
  /**
   * 规格型号
   */
  model?: string
  /**
   * 客户订单号id
   */
  orderId?: string
  /**
   * 客户订单号
   */
  orderNo?: string
  /**
   * 单价
   */
  price?: number
  /**
   * 物料编码
   */
  productCode?: string
  /**
   * 退货单采购订单号
   */
  purchaseOrderNo?: string
  /**
   * 退货数量
   */
  returnNum?: number
  /**
   * 退货单明细id
   */
  returnOrderDetailId?: string
  /**
   * 退货单id
   */
  returnOrderId?: string
  /**
   * 退货单编号
   */
  returnOrderNo?: string
  /**
   * 税率
   */
  taxRate?: number
  /**
   * 合计金额
   */
  totalAmount?: number
  /**
   * 价税合计
   */
  totalAmountIncludingTax?: number
  /**
   * 合计税额
   */
  totalTaxAmount?: number
  titleOfTheContract: string
  returnTime: number
  [property: string]: any
}

export interface LanderInvoiceDetailData {
  dataState: string
  invoiceTotalAmountIncludingTax: string
  orderTotalAmountIncludingTax: string
  rejection: string
  orders: orderItem[]
  invoices: InvoiceParamItem[]
  logisticsCompany: string // 物流公司
  logisticsNum: string // 物流单号
  returnDetailList: ReturnOrderDetailVo[]
}

// 获取发票单详情-电商供应商订单
export const GET_INVOICE_DETAIL_DATA = (params: { relationDataId: string }) =>
  GET<LanderInvoiceDetailData>(`${HTTP}/input/invoice/relation/details`, params)

// 发票单-供应商订单明细
export interface SupplierOrderItem {
  code: string // 采购单号
  createTime: number // 创建时间
  finalPrice: number // 最终结算金额
  id: string // 订单id
  number: number // 结算件数
  receiveMan: string // 收件人
}
export interface SupplierInvoiceDetailData {
  dataState: string
  invoiceTotalAmountIncludingTax: string
  orderTotalAmountIncludingTax: string
  rejection: string
  orders: SupplierOrderItem[]
  invoices: InvoiceParamItem[]
  logisticsCompany: string // 物流公司
  logisticsNum: string // 物流单号
}

// 获取发票单详情-供应商订单
export const GET_SUPPLIER_INVOICE_DETAIL_DATA = (params: {
  relationDataId: string
}) =>
  GET<SupplierInvoiceDetailData>(
    `${HTTP}/input/invoice/relation/supplier/invoice/details`,
    params,
  )

// 获取已验真发票的数据
export const GET_VERIFICATION_RESULT = (params: InvoiceVerificationParams) =>
  POST(`${HTTP}/input/invoice/verification-result`, params, 'application/json')

// 获取已验真发票的数据 - 改为GET
export const GET_VERIFICATION_RESULT_DATA = (params: { invoiceNum: string }) =>
  GET(`${HTTP}/input/invoice/ocr-recognition-result`, params)

// 删除暂存的发票
export const DELETE_INVOICE_ITEM = (params: { invoiceOrderId: string }) =>
  DELETE(`${HTTP}/input/invoice`, params, 'multipart/form-data')

// 发票录入页-电商供应商订单明细导出
export const DOWNLOAD_INVOICE_ACCEPT_TEMP = (params: { orderIds: string }) =>
  downFileGET(`${HTTP}/input/invoice/exportDetail`, params)

// 保存发票录入页物流信息
export const SAVE_INVOICE_LOGISTICS = (params: {
  logisticsCompany: string // 物流公司
  logisticsNum: string // 物流单号
  invoiceOrderId: string
}) => POST(`${HTTP}/input/invoice/logistics`, params, 'application/json')

// 物流轨迹
export interface LogisticsInformation {
  AcceptStation: string
  AcceptTime: string
  accept_address: string
  opcode: string
}

// 获取发货单物流轨迹
export const GET_LOGISTICS_INFORMATION = (params: {
  expressCode: string // 物流公司编码
  expressNo: string // 物流单号
  id: string // 发货单id
  phoneNumber: string // 联系方式
}) =>
  POST<LogisticsInformation[]>(
    `${HTTP}/supplierOrder/getLogisticsInformation`,
    params,
    'application/json',
  )

// 下载订单附件
export const DOWNLOAD_ORDER_FILE = (params: {
  url: string
  fileName: string
}) => downFileGET(`${HTTP}/download/file`, params)

// 供应商订单拒单
export const REFUSE_SUPPLIER_ORDER = (params: {
  orderId: string // 订单id
  refuseReason: string // 拒单理由
  refuseOperatorId: string // 拒单操作人id
}) => GET(`${HTTP}/supplierOrder/refuseOrder`, params)

interface SupplierInvoiceEntryParams {
  supplierOrderCode?: string // 采购订单号
  pageNo?: number
  pageSize?: number
  receiveMan?: string // 收件人
  schemeId?: string
  excludeOrderIds?: string
}
interface SupplierInvoiceOrder {
  code: string // 采购订单
  createTime: number // 下单时间
  finalPrice: number // 最终结算金额
  id: string
  number: number // 结算件数
  receiveMan: string // 收件人
}
// 分页获取供应商可开票列表
export const GET_INVOICE_SUPPLIER_ORDER_PAGE = (
  params: SupplierInvoiceEntryParams,
) =>
  GET<TableRes<SupplierInvoiceOrder>>(
    `${HTTP}/input/invoice/supplierOrder/page`,
    {
      ...params,
      supplierUserId: getUserId(),
      supplierId: getSupplierId(),
    },
  )

// 发票录入页-供应商明细导出
export const EXPORT_SUPPLIER_ORDER_DETAIL = (params: { orderIds: string }) =>
  downFileGET(`${HTTP}/input/invoice/exportSupplierOrderDetail`, params)

// 发票录入页-供应商订单导出寄票随单
export const DOWNLOAD_SUPPLIER_ORDER_ACCEPT_TEMP = (params: string[]) =>
  downFilePost(`${HTTP}/input/invoice/downloadSupplierOrderAcceptTemp`, params)

interface ProductUrlItem {
  pictureUrl: string
  productCode: string
}

// 批量获取商品图
export const BATCH_GET_PRODUCT_PICTURE = (params: { productCodes: string[] }) =>
  POST<ProductUrlItem[]>(
    `${HTTP}/order/batchGetProductPicture`,
    params,
    'application/json',
  )

// 上传合同
export const UPLOAD_ORDER_PURCHASE_CONTRACT = (orderId: string, file: RcFile) =>
  POST(
    `${HTTP}/order/uploadPurchaseContract?orderId=${orderId}`,
    { file },
    'multipart/form-data',
  )

export const UPLOAD_ORDER_DESCRIPTION = (orderId: string, file: RcFile) =>
  POST(
    `${HTTP}/order/uploadOrderDescription?`,
    { orderId, file },
    'multipart/form-data',
  )

export const GET_ORDER_DESCRIPTION = (orderId: string) =>
  GET(
    `${HTTP}/order/getOrderDescriptionDetail`,
    { orderId },
    'application/json',
  )

export const ADD_ORDER_DESCRIPTION = (params: {
  orderDescriptionTextField: string
  orderId: string
  orderDescriptionFileList: string[]
}) =>
  POST(`${HTTP}/order/addOrUpdateOrderDescription`, params, 'application/json')

// 红票录入相关接口类型定义
export interface RedInvoiceReturnDetail {
  /**
   * 品牌
   */
  brand?: string
  /**
   * 发货明细id
   */
  deliveryDetailId?: string
  /**
   * 规格型号
   */
  manuCode?: string
  /**
   * 物料编码
   */
  productCode?: string
  /**
   * 商品名称
   */
  productName?: string
  /**
   * 单价（含税）
   */
  productPrice?: number
  /**
   * 退货数量
   */
  returnNum?: number
  /**
   * 税率
   */
  taxRate?: number
  /**
   * 合计金额（不含税金额）
   */
  totalAmount?: number
  /**
   * 价税合计（含税总金额）
   */
  totalAmountIncludingTax?: number
  /**
   * 合计税额
   */
  totalTaxAmount?: number
  /**
   * 单位
   */
  unit?: string
}

/**
 * 蓝票信息内部类
 *
 * BlueInvoiceInfo
 */
export interface BlueInvoiceInfo {
  /**
   * 对应的进项票id
   */
  inputInvoiceId?: string
  /**
   * 蓝票号码
   */
  invoiceNum?: string
  [property: string]: any
}

export interface RedInvoiceEntryItem {
  id: string // ID
  orderNo: string // 客户订单号
  /**
   * 客户订单已开蓝票信息列表
   */
  blueInvoiceInfos?: BlueInvoiceInfo[]
  // blueInvoiceNum: string // 客户订单已开蓝票号码
  returnNo: string // 退货单号
  customerName: string // 客户名称
  consignee: string // 收件人
  platform: string // 下单平台
  platformCode: string // 下单平台编码
  titleOfTheContract: string // 签约抬头
  titleOfTheContractName: string // 签约抬头名称
  returnTime: number // 退货时间（毫秒时间戳）
  taxRate: number // 税率
  returnAmount: number // 退货金额
  redInvoiceState: string // 红票状态
  redInvoiceStateName: string // 红票状态名称
  returnDetailList: RedInvoiceReturnDetail[] // 退货明细列表
}

export interface RedInvoiceEntryParams {
  supplierId?: string // 供应商ID（必填）
  schemeId?: string // 搜索方案ID
  userId?: string // 用户ID
  orderNo?: string // 客户订单号
  blueInvoiceNum?: string // 客户订单已开蓝票号码
  returnNo?: string // 退货单号
  customerName?: string // 客户名称
  consignee?: string // 收件人
  platformCode?: string // 下单平台（多选用逗号分隔）
  titleOfTheContract?: string // 签约抬头
  returnStartTime?: number // 退货时间开始（毫秒时间戳）
  returnEndTime?: number // 退货时间结束（毫秒时间戳）
  pageNo?: number // 页码，默认1
  pageSize?: number // 每页大小，默认20
}

// 分页获取红票录入列表
export const GET_RED_INVOICE_ENTRY_PAGE = (params: RedInvoiceEntryParams) =>
  GET<TableRes<RedInvoiceEntryItem>>(`${HTTP}/input/invoice/red`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

// 红票录入保存相关类型定义
export interface FileDTO {
  id?: string // id
  name?: string // 附件名
  url?: string // 附件路径
  baseUrl?: string // 前缀路径
  type?: string // 文件类型
}

export interface RedInvoiceParam {
  id?: string // id，修改时传入
  invoiceType: string // 发票类型 {@link com.xhgj.srm.common.enums.InvoiceTypeEnum}
  invoiceNum: string // 发票号码
  invoiceCode?: string // 发票代码
  invoiceTime: number // 开票时间（毫秒时间戳）
  totalAmount: number // 合计金额
  totalTaxAmount?: number // 合计税额
  totalAmountIncludingTax: number // 价税合计
  file?: FileDTO // 发票附件
  verificationType?: string // 验真类型
  relationId?: string // 关联数据id
  checkCode?: string // 校验码
  seller?: string // 销方
}

export interface RedInvoiceEntrySaveParam {
  relationId?: string // 红票 进项票ID（编辑时传入）
  returnOrderIds: string[] // 退货单ID列表
  invoiceParams: RedInvoiceParam[] // 红票发票信息列表
  supplierId?: string // 供应商ID
  userId?: string // 操作人ID
  isDraft?: boolean // 是否暂存（true-暂存，false-提交），默认true
}

/**
 * 红票录入保存
 * @param params 红票录入保存参数
 * @returns
 */
export const SAVE_RED_INVOICE_ENTRY = (params: RedInvoiceEntrySaveParam) =>
  POST(
    `${HTTP}/input/invoice/red`,
    {
      ...params,
      supplierId: getSupplierId(),
      userId: getUserId(),
    },
    'application/json',
  )

//  批量下载合同到压缩包
export const BATCH_DOWNLOAD_ZIP_THE_CONTRACT = (params: ExportZipParams) =>
  POST(`${HTTP}/order/batchDownloadZipTheContract`, params, 'application/json')

export interface TransferDispatchParam {
  orderId: string
  supplierId: string
  supplierName: string
  detailList: DetailParam[]
}

export interface DetailParam {
  /** 订单履约物料行id */
  detailId: string

  /** 转派数量（数量-退货-取消） */
  num: number
}

// 订单转派
export const POST_TRANSFER_DISPATCH = (params: TransferDispatchParam) =>
  POST(`${HTTP}/order/transferDispatch`, params, 'application/json')

/** /supplier/findBy 单条 */
export interface SupplierFindByDTO {
  id: string
  name: string
}

/** 按名称查询供应商（订单转派页搜索） */
export const GET_SUPPLIER_CAN_TRANSFER = (params: {
  name: string
  type: string
}) => GET(`${HTTP}/supplier/findBy`, params)
import { RcFile } from 'antd/lib/upload'
import { TableRes } from '../global'
import { MaterialFilesType } from '../modules/goodsdetailmodules/uploadfiles'
import request from '../tools/request'
import { ResultState } from '../tools/public'
import { AccountStatusKey, accountOpenInvoiceStateKey } from '../tools/state'
import { GetLocalStorage, getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
const { GET, POST, downFilePost, uploadFilePOST, downFileGET, DELETE } = request

// 订单管理模块api
// 订单履约模块
/**
 * 获取订单状态及其个数
 * @param params
 * @returns
 */
export const GET_ORDER_STATE_COUNT = (params: { supplierId: string }) =>
  GET(`${HTTP}/order/getOrderStateAndCount`, params)

export type OrderPageRes = {
  accountNo: string
  accountOpenInvoiceStatus: string
  accountStatus: string
  address: string
  consignee: string
  createTime: string
  customer: string
  customerInvoice: string
  customerReturnProgress: string
  id: string
  invoicingState: string
  logisticsNum: string
  mobile: string
  orderNo: string
  orderState: string
  paymentStatus: string
  platform: string
  price: number
  progress: string
  redSport: boolean
  signVoucherState: string
  title: string
  type: string
  dispatchTime: number
  shipmentOverdueTime: number
  properOverdueTime: number
  shipmentOverdue: boolean
  properOverdue: boolean
  shipmentOverdueDesc: string
  properOverdueDesc: string
  shipmentFeedbackList?: OverdueFeedbackItem[]
  properFeedbackList?: OverdueFeedbackItem[]
}

export type OverdueFeedbackAttachment = {
  fileName: string
  fileUrl: string
}

export type OverdueFeedbackItem = {
  feedbackType: '1' | '2'
  expectFinishTime: string
  createTime: string
  reason: string
  attachments?: OverdueFeedbackAttachment[]
}

export type OrderPageParam = {
  address?: string // 收货地址
  consignee?: string // 收件人
  customer?: string // 客户名称
  endDate?: string // 下单日期(截止)
  invoicingState?: string // 开票状态(1--已开票,2--未开票)
  mobile?: string //	联系方式
  orderNo?: string //	客户订单号
  orderPageState?: string // 订单页签状态(空 全部 1--待履约,2--履约中,3--待验收,4-已完成 0-已完成和已结束)
  orderState?: string
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  salesReturnState?: boolean
  schemeId?: string //	方案id
  startDate?: string //	下单日期(起始
  // supplierId: string //供应商id
  accountStatus?: string // 对账状态
  accountOpenInvoiceStatus?: string // 对账开票状态
  cancelState?: boolean
  positiveActualAmountOnly?: boolean
  materialCode?: string
  productName?: string
  brand?: string
  /** 超期类型筛选，多值逗号拼接；订单超期 tab(numMap=5) 默认 1,2 */
  overdueType?: string
  // userId: string // 用户id
}

export type ExportZipParams = OrderPageParam & {
  ids: string[]
}
/**
 * 分页获取订单信息
 * @param params
 * @returns
 */
export const GET_ORDER_PAGE = (params: OrderPageParam) =>
  GET<TableRes<OrderPageRes>>(`${HTTP}/order/getOrderPage`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

export type SuppplierOrderParam = {
  directShipment?: string // 是否厂家直发
  endTime?: string // 结束时间
  groupName?: string // 采购组织
  supplierOrderState?: string // 订单页签状态(0--完成,1--待履约,2--履约中,3--待验收)
  scpShipStatus?: string // scp发货状态 WAIT-待发货，COMPLETE-已完成
  orderState?: string
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  receiveMan?: string // 收件人
  schemeId?: string //	方案id
  stateTime?: string // 开始时间
  // supplierId: string //供应商id
  // userId: string // 用户id
  confirmState?: boolean // 是否待确认
  cancelState?: boolean // 是否有取消
  returnState?: boolean // 是否有退货
  refuseState?: boolean // 是否拒单
  materialCode?: string
  productName?: string
  brand?: string
  supplierOpenInvoiceState?: string // 供应商开票状态
}

/**
 * 分页获取供应商订单接口
 * @param params
 * @returns
 */
export const GET_SUPPLIER_ORDER_PAGE = (params: SuppplierOrderParam) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderPage`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

// 供应商信息
export const GET_TAB_SUPPLIER_ORDERCOUNT = (params: SuppplierOrderParam) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderCount`, params)

export type AcceptInfoItem = {
  acceptList: { baseUrl: string; id: string; name: string; url: string }[]
  createTime: number | string
  id: string
  type: string
  uploadMan: string
  auditMan: string
  auditState: string // 审核状态
  groundsForRejection: string // 驳回理由
}

export type ProductList = {
  brand: string
  cancelCount: number
  code: string
  delCount: number
  id: string
  imgUrl: string // 商品图片地址
  isDisabled: boolean
  /** 有值表示转派，前端用于禁用行勾选 */
  transferSupplierName?: string
  model: string
  name: string
  num: number
  price: number
  progress: string
  reCount: number
  salePrice: number // 销售单价
  unCount: number
  unit: string
  rowId?: string
  costPriceTaxRate?: string
  orderNo?: string
  systemCategoryCode?: string
}

export type OrderDteailRes = {
  paymentMethodList: string[]
  cancelPrice: string
  acceptInfoDTOS: AcceptInfoItem[]
  accountNo: string
  accountId: string
  accountStatus: string
  accountOpenInvoiceStatus: string
  address: string
  allShipTime: number
  checkState: string
  confirmVoucherTime: number
  consignee: string
  createTime: string
  customer: string
  returnState: string
  firstShipTime: number
  id: string
  supplierOrderId?: string
  invoicingState: string
  mobile: string
  orderNo: string
  orderState: string
  orderPaymentId: string
  platform: string
  platformCode: string
  orderTransferSupported: boolean
  price: number
  progress: string
  refundPrice: number
  settlePrice: number
  paymentStatus: string
  remark: string
  signVoucherState?: string
  invoiceApplicationNum: string
  orderInvoiceId: string
  prohibitionPaymentState: boolean
  dispatchTime: number
  titleOfTheContract?: string
  acceptAuditState?: string
  acceptAuditMan?: string
  acceptGroundsForRejection?: string
  purchaseOrderContract?: any
  customerInfoAttachments?: any
  orderRemark?: string
  shipmentOverdueTime?: number
  properOverdueTime?: number
  shipmentOverdue?: boolean
  properOverdue?: boolean
  shipmentOverdueDesc?: string
  properOverdueDesc?: string
}
/**
 * 获取订单详情
 * @param params 订单id
 * @returns
 */
export const GET_ORDER_DETAIL = (params: { orderId: string }) =>
  GET<OrderDteailRes>(`${HTTP}/order/getOrderDetail`, params)

export type ListDetail = {
  cancelInfoVO: any
  returnInfoVO: {
    erpNo: string // erp采购退料单号
    returnDetailList: {
      brand: string
      manuCode: string
      productCode: string
      productName: string
      productPrice: number
      returnNum: number
      unit: string
    }[]
    returnNo: string
    returnId: string
    returnPrice: number
    returnTime: number
    state: string
  }[]
  productDetailVO: ProductList[]
  deliveryDetailVO: {
    deliveryProductList: {
      brand: string
      code: string
      delCount: number
      id: string
      model: string
      name: string
      num: number
      price: number
      unit: string
    }[]
    deliveryTime: string
    expressCompany: string
    expressNo: string
    id: string
    state: string
  }[]
}
// 获取订单详情明细表格数据
export const GET_ORDER_PRODUCT_INFO = (params: { orderId: string }) =>
  GET<ListDetail>(`${HTTP}/order/getOrderProductInfo`, params)

interface DataInfoItem {
  fileIdList: string[]
  id: string // 签收单信息 id
  type: string
}

export const SUBMIT_ORDER_ACCEPT = (params: {
  dataInfo: DataInfoItem[]
  orderId: string // 订单 id
  // uploadMan: string
}) =>
  POST(
    `${HTTP}/order/submitOrderAccept`,
    {
      ...params,
      uploadMan: getUserId(),
    },
    'application/json',
  )

export const DOWNLOAD_PURCHASEORDERCONTRACT = (params: { orderId: string }) =>
  downFilePost(
    `${HTTP}/order/downloadPurchaseOrderContract?orderId=${params.orderId}`,
  )

export const DOWNLOAD_SUPPLIERORDERCONTRACT = (params: { orderId: string }) =>
  downFilePost(
    `${HTTP}/supplierOrder/downloadPurchaseOrderContract?orderId=${params.orderId}`,
  )
export interface DetailedProductDTOList {
  brand: string
  cancelQty: number
  detailId: string
  id: string
  mainPicture?: string | null
  isDisabled: boolean
  manuCode: string
  num: number
  productCode: string
  productName: string
  productPrice: number
  returnQty: number
  settleQty: number
  shipQty: number
  stockInputQty: number
  stockOutputQty: number
  unit: string
  unitDigit: number
  waitQty: number
  progress?: any
}
export type SignVoucherFileItem = {
  id: string
  url: string
  baseUrl: string
  name: string
  type: string
}

export type SignVoucherUploadFileItem = {
  filename: string
  newFilePath: string
  newFileName?: string
  fileRes?: string
  baseUrl?: string
  type?: string
  relationType?: string
}

export type DirectedSignVoucher = {
  signVoucherState?: string
  signVoucherRejectReason?: string
  signVoucherTime?: string
  signVoucherFiles?: SignVoucherFileItem[]
}

export type SupplierOrderDetailRes = {
  cancelReturnPrice: number
  code: string
  detailedProductDTOList: DetailedProductDTOList[]
  directShipment: boolean
  finalPrice: Record<string, unknown>
  groupName: string
  id: string
  orderCreateTime: string
  orderState: string
  orderStateToName: string
  price: string
  purchaseGroupName: string
  purchaseMan: string
  receiveAddress: string
  receiveMan: string
  receiveMobile: string
  warehousingProgress: string
  customerOrderCode: string
  scpShipStatusName: string
  scpShipStatus: string
  orderType?: string
  signVoucherFiles?: SignVoucherFileItem[]
  signVoucherState?: string
  signVoucherRejectReason?: string
  signVoucherTime?: string
  allShipped?: boolean
  directedApplyNo?: string
  directedSignVoucher?: DirectedSignVoucher
}

/**
 * 获取供应商订单详情
 * @param params 订单id
 * @returns
 */
export const GET_SUPPLINER_ORDER_DETAIL = (params: { id: string }) =>
  GET<SupplierOrderDetailRes>(`${HTTP}/supplierOrder/getSupplierOrder`, params)

/**
 * 上传签收凭证
 */
export const UPLOAD_SIGN_VOUCHER = (params: {
  orderId: string
  fileList: SignVoucherUploadFileItem[]
}) =>
  POST(`${HTTP}/supplierOrder/uploadSignVoucher`, params, 'application/json')

/**
 * 删除签收凭证
 */
export const DELETE_SIGN_VOUCHER = (params: { id: string }) =>
  POST(`${HTTP}/supplierOrder/deleteSignVoucher`, params, 'application/json')

/**
 * 获取供应商发货单明细
 * @param params 订单id
 * @returns
 */
export const GET_SUPPLINER_ORDER_SHIP = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderShipById`, params)

/**
 * 获取供应商退货单明细
 * @param params 订单id
 * @returns
 */
export const GET_SUPPLINER_ORDER_RETURN = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderReturnById`, params)

/**
 * 获取供应商取消单明细
 * @param params 订单id
 * @returns
 */
export const GET_SUPPLINER_ORDER_CANCEL = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrder/getSupplierOrderCancelById`, params)

/**
 * 下载验收单模板
 * @returns
 */
export const DOWNLOAD_ACCEPT_TEMP = (params: { id: string }) =>
  downFilePost(`${HTTP}/order/downloadAcceptTemp`, params)

/**
 * 下载客户定制验收单模板
 * @param params 订单id
 * @returns
 */
export const DOWNLOAD_CUSTOM_ACCEPT_TEMP = (params: { id: string }) =>
  downFilePost(`${HTTP}/order/downloadAcceptTemp2`, params)

export const DOWNLOAD_ZIP_MORE = (params: { fileIdList: string[] }) =>
  downFilePost(`${HTTP}/upload/downloadZipMoreFile`, params)

/**
 * 确认订单
 * @returns
 */
export const CONFIRM_ORDER = (params: { id: string }) =>
  POST(`${HTTP}/supplierOrder/confirmOrder`, params, 'application/json')

export interface MSGPARAMS {
  supplierId?: string
  type?: string
  userId?: string
  schemeId?: string
  content?: string
  pageNo: number
  pageSize: number
  readState?: boolean
}
/**
 * 获取消息列表
 * @param MSGPARAMS
 * @returns
 */
export const GET_MESSAGE_LIST = (params: MSGPARAMS) =>
  GET<TableRes<NoticeItemRes>>(`${HTTP}/noticeCenter/getPage`, params)

export type NoticeItemRes = {
  content: string
  id: string
  isRead: boolean
  time: string
  type: string
  typeToName: string
  title?: string
}
export const GET_MESSAGE_LIST_PAGE = (params: MSGPARAMS) =>
  GET<TableRes<NoticeItemRes>>(`${HTTP}/noticeCenter/getPage`, {
    supplierId: getSupplierId(),
    userId: getUserId(),
    ...params,
  })

export type MessageItem = {
  content: string
  id: string
  isRead: boolean
  time: string
  type: string
  typeToName: string
}

/**
 * 获取消息列表
 * @param MSGPARAMS
 * @returns
 */
export const GET_MESSAGE_SIZE_LIST = (params: {
  supplierId: string
  size?: number
}) => GET<MessageItem[]>(`${HTTP}/noticeCenter/getNoticeCenterList`, params)

export type MessageDetailRes = {
  content: string
  id: string
  supplierOrderId: string
}

/**
 * 获取消息详情
 * @param id
 * @returns
 */
export const GET_MESSAGE_DETAIL = (params: { id: string }) =>
  GET<MessageDetailRes>(`${HTTP}/noticeCenter/get`, params)

interface PRODUCTDATAIL {
  brand?: string // 品牌
  deliveryQty?: string // 本次发货数量
  id?: string //
  manuCode?: string // 规格型号
  productCode?: string // 物料编码
  productName?: string // 商品名称
  productPrice?: string // 单价
  unit?: string // 单位
  unitDigit?: string // 数量
  waitQty?: string // 待发数量
}
/**
 * 新建发货单订单
 * @returns
 */
export const NEW_SUPPLIER_ORDER = (params: {
  id: string
  logisticsCompany: string // 快递公司
  logisticsCode: string // 物流单号
  trackNum: string // 快递编码
  // logisticsCompanyCode: string
  productDetailList: PRODUCTDATAIL[]
  code: string // 快递code
  receiveMan: string // 收货人
  receiveMobile: string // 收货人手机号
  receiveAddress: string // 收货地址
}) =>
  POST(
    `${HTTP}/supplierOrder/supplierOrderDelivery`,
    {
      ...params,
      supplierId: getSupplierId(),
    },
    'application/json',
  )

/**
 * 修改物流公司
 * @returns
 */
export const CHANGE_EXPRESSCOMPANY = (params: {
  id: string
  logisticsCompany: string // 快递公司
  logisticsCode: string
  trackNum: string
  // logisticsCompanyCode: string
}) =>
  POST(`${HTTP}/supplierOrder/updateLogisticsInfo`, params, 'application/json')

/**
 * 确认收货
 * @returns
 */
export const CONFIRM_GOODS = (params: { id: string }) =>
  POST(`${HTTP}/supplierOrder/confirmReceipt`, params, 'application/json')

/**
 * 确认收货
 * @returns
 */
export const ORDER_STORY = (params: { id: string }) =>
  GET(`${HTTP}/supplierOrder/getOrderProgressTime`, params)

/**
 * 导出全部明细
 * @returns
 */
export const EXPORT_ALL_DETAIL = (params: { id: string }) =>
  POST(
    `${HTTP}/supplierOrder/exportSupplierOrderDetails`,
    params,
    'multipart/form-data',
  )

/**
 * 导出配货单
 * @returns
 */
export const EXPORT_ORDER_DETAIL = (params: { orderId: string }) =>
  downFileGET(`${HTTP}/supplierOrder/exportSupplierOrderShipDetails`, params)

// 导出配货单-发货明细列表
export const EXPORT_ORDER_SHIP_DETAIL = (params: { shippingOrderId: string }) =>
  downFileGET(
    `${HTTP}/supplierOrder/exportSupplierOrderShipDetailsByShippingOrderId`,
    params,
  )

export type ExpressCompanyRes = { expressCode: string; expressCompany: string }

/**
 * 获取物流公司选择列表
 * @returns
 */
export const GET_EXPRESSCOMPANY_LIST = (params: {
  type: string // 下单平台
}) => GET<ExpressCompanyRes[]>(`${HTTP}/order/getExpressCompanyList`, params)

/**
 * 获取OMS承运商物流公司列表
 * @returns
 */
export const GET_OMS_EXPRESSCOMPANY_LIST = () =>
  GET<ExpressCompanyRes[]>(`${HTTP}/order/getLogisticsCompany`)

interface Product {
  brand?: string // 品牌
  code?: string // 物料编码
  delCount?: number // 发货数量
  id?: string // 明细id
  model?: string // 型号
  name?: string // 商品名称
  num?: number // 数量
  price?: number // 单价
  reCount?: number // 退货数量
  unCount?: number // 未发数量
  unit?: string // 单位
  rowId?: string // 物料行id
  costPriceTaxRate?: string // 成本价税率
}
/**
 * 新建发货单
 * @returns
 */
export const ORDER_DELIVERY = (params: {
  expressCode: string // 物流公司编码
  expressCompany: string // 物流公司
  expressNo: string // 物流单号
  orderId: string
  productDetailList: Product[]
}) =>
  POST(
    `${HTTP}/order/orderDelivery`,
    { ...params, supplierId: getSupplierId() },
    'application/json',
  )

/**
 * 变更发货单
 * @returns
 */
export const ORDER_DELIVERY_UPDATE = (params: {
  expressCode: string // 物流公司编码
  expressCompany: string // 物流公司
  expressNo: string // 物流单号
  orderId: string // 订单id
  deliveryId: string // 发货单id
  // productDetailList: Product[]
}) => POST(`${HTTP}/order/orderDeliveryUpdate`, params, 'application/json')

type CertificateType =
  | 'account'
  | 'invoice'
  | 'twoOrder'
  | 'orderInvoice' // 电商供应商附件
  | 'orderOtherFile'
  | 'mainPicture' // 主图
  | 'detailsPicture' // 详情图
  | 'contract'
  | 'priceSupportingEvidence' // 价格佐证
  | 'scpImportProduct' // 订单报备 -> 商品报备 -> 导入
  | 'regionalStock' // 导入区域库存
  | MaterialFilesType
  | 'materialAptitude' // 资质图片
  | 'inquiryImportSCP' // 询价单导入SCP
  | 'orderOverdueFeedback'

export const certificateTypeDict: { [key: string]: string } = {
  '1': '两单',
  '2': '咸亨验收单',
}

/**
 * 上传验收单|对账单    对账单上传的时候可以不带code
 * @param params
 * @param file 验收单文件列表  code 订单id
 * @returns
 */
export type uploadType = CertificateType
export const UPLOAD_FILES = (
  params: {
    type?: CertificateType
    code?: string
  },
  file: any,
) =>
  uploadFilePOST(`${HTTP}/upload/uploadFiles`, file, {
    ...params,
    uploadMan: GetLocalStorage('USER_NAME'),
  })

/**
 * 删除附件，文件id在上传验收单的时候接口会返回
 * @param params
 * @returns
 */
export const DETELE_FILE = (params: {
  id: string // 文件id
}) => POST(`${HTTP}/upload/deleteFile`, params, 'application/json')

/**
 * 获取发货单详情
 * @param params 订单id
 * @returns
 */
export const GET_ORDER_DELIVERY_DETAIL = (params: {
  orderDeliveryId: string
}) => GET(`${HTTP}/order/getOrderDeliveryDetail`, params)

/**
 * 获取退货单订单状态及其个数
 * @param params
 * @returns
 */
export const GET_ORDERRETURN_STATECOUNT = (params: { supplierId: string }) =>
  GET(`${HTTP}/return/getOrderReturnStateCount`, params)

export type ReturnManagementParam = {
  address?: string // 收货地址
  consignee?: string // 收件人
  customer?: string // 客户名称
  mobile?: string //	联系方式
  orderNo?: string //	客户订单号
  orderReturnNo?: string // 退货单号
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  returnApplyStartDate?: string
  returnApplyEndDate?: string
  returnCount?: number // 退货数量
  returnPrice?: number // 退货金额
  returnState?: string // 单子状态(0--全部,1--退货申请/取消申请,2--退货中,3--已完结)
  returnType?: string // 单子类型(1--退货单,2--取消单)
  schemeId?: string //	方案id
  // supplierId: string //供应商id
}
/**
 * 分页获取退货单订单信息
 * @param params
 * @returns
 */
export const GET_RETURNORDER_PAGE = (params: ReturnManagementParam) =>
  GET(`${HTTP}/return/getReturnOrderPage`, {
    ...params,
    supplierId: getSupplierId(),
  })

/**
 * 分页获取供应商退货单订单信息
 * @param params
 * @returns
 */
export const GET_SUPPLIER_RETURNORDER_PAGE = (params: {
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  schemeId?: string //	方案id
  supplierId: string // 供应商id
  status?: string
  supplierOrderDirectShipment?: boolean // 是否厂家直发
  supplierOrderReturnCode?: string // 采购订单号
  supplierOrderReturnEndTime?: string // 结束时间
  supplierOrderReturnGroupName?: string // 采购组织
  supplierOrderReturnNum?: string // 件数
  supplierOrderReturnNumber?: string // 单号
  supplierOrderReturnPrice?: string // 金额
  supplierOrderReturnReceiveMan?: string // 采购员
  supplierOrderReturnStartTime?: string // 开始
  supplierOrderReturnType?: string // 单据类型
  userId?: string
}) => GET(`${HTTP}/supplierOrderReturn/getSupplierOrderReturnPage`, params)

export type FillingRes = {
  arriveTime: string
  customer: string
  filingNo: string
  filingTime: string
  filingType: string
  id: string
  orderNo: string
  platform: string
  price: number
  state: string
}

/**
 * 分页获取报备单信息
 * @param params
 * @returns
 */
export const GET_FILING_PAGE = (params: {
  customer?: string // 客户名称
  filingArriveEndTime?: string // 到期日(截止)
  filingArriveStartTime?: string // 到期日(起始)
  filingEndTime?: string // 报备日期(截止)
  filingNo?: string //	报备单号
  filingOrderEndTime?: string // 预计点单日(截止)
  filingOrderStartTime?: string // 预计点单日(起始)
  filingStartTime?: string // 报备日期(起始)
  fillingState?: string // 报备单状态(1--报备中,2--已派单,3--已撤回)
  num?: number // 报备数量
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  price?: number // 退货金额
  schemeId?: string //	方案id
  supplierId: string // 供应商id
  supplierUserId: string // 用户id
}) => GET<TableRes<FillingRes>>(`${HTTP}/filing/getFilingPage`, params)

/**
 * 分页获取对账单信息
 * @param params
 * @returns
 */
export const GET_ACCOUNT_PAGE = (params: {
  accountEndTime?: string // 提交日期(截止)
  accountNo?: string // 对账单号
  accountStartTime?: string // 提交日期(起始)
  accountState?: string // 对账单状态(1--待确认,2--已确认,3--已部分回款,4--已回款,5--已作废)
  accountOpenInvoiceStatus?: string // 供应商开票(1--未开票,2--已开票)
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  price?: number // 对账金额
  returnPrice?: number // 已回金额
  schemeId?: string //	方案id
  supplierId: string // 供应商id
}) => GET(`${HTTP}/supplier/invoice/getAccountPage`, params)

interface FileList {
  baseUrl: string
  id: string
  name: string
  url: string
}
interface ProductInfoList {
  brandName: string
  model: string
  orderNo: string
  productCode: string
  productCount: number
  productId: string
  productName: string
  productPrice: number
  unit: string
}
export interface OrderInfoList {
  customer: string
  customerPayback: string
  finalPrice: number
  orderId: string
  orderInvoiceStatus: string
  orderNo: string
  orderPrice: number
  orderTime: number
  platform: string
  signVoucherState: string
}
export interface OrderAccountInvoiceInfoList {
  accountInvoiceId: string
  fileList: FileList[]
  invoiceCode: string
  invoiceNum: string
  invoiceTime: number
  logisticsCompany: string
  logisticsNum: string
  price: number
}
export interface AccountDetailRes {
  accountNo: string
  accountOpenInvoiceStatus: accountOpenInvoiceStateKey
  accountPrice: number
  accountStatus: AccountStatusKey
  commitTime: string
  confirmMan: string
  confirmTime: string
  createSupplier: string
  createTime: string
  id: string
  orderAccountInvoiceInfoList: OrderAccountInvoiceInfoList[]
  orderInfoList: OrderInfoList[]
  productInfoList: ProductInfoList[]
  supplierRemark: string
  groundsForRejection: string
}

/**
 * 获取对账单详情
 * @param
 * @returns
 */
export const GET_ACCOUNT_DETAIL = (params: { accountId: string }) =>
  GET<AccountDetailRes>(`${HTTP}/input/invoice/getAccountDetail`, params)

interface InvoiceInfoParams {
  accountInvoiceId?: string
  fileIds: string[]
  invoiceCode: string
  invoiceNum: string
  invoiceTime: number
  logisticsCompany: string
  logisticsNum: string
  price: number
}
interface CommitAccountParams {
  addInvoiceInfoParams: InvoiceInfoParams[]
  id?: string // 对账单id(修改传入)
  orderList?: any[] // 订单明细
  type?: string // 提交类型(1--提交开票,2--暂存)
}

/**
 * 获取已验收订单信息
 * @param params
 * @returns
 */
export const GET_DONE_ORDER_LIST = (params: {
  consignee?: string // 收件人
  customer?: string //	客户名称
  orderEndTime?: string // 下单时间(截止)
  mobile?: string // 联系方式
  orderNo?: string //	客户订单号
  platform?: string // 下单平台
  settlePrice?: string //	最终结算金额
  orderStartTime?: string // 下单时间(开始)
  supplierId: string // 供应商id
}) => GET(`${HTTP}/supplier/invoice/getDoneOrderList`, params)

interface UpdateAccountParams extends CommitAccountParams {
  detailIds: string[] // 删除的订单列表
}

/**
 *更新对账单
 * @returns
 */
export const UPDATE_ACCOUNT = (params: UpdateAccountParams) =>
  POST(`${HTTP}/supplier/invoice/updateAccount`, params, 'application/json')

type InvoicePageRes = {
  createTime: string
  customer: string
  invoicingState: string
  orderNo: string
  platform: string
  price: number
}

export type InvoicePageParam = {
  createTime?: string // 下单时间
  customer?: string // 下单名称
  invoicingState?: string // 开票状态
  logisticsNum?: string // 物流单号
  orderNo?: string // 客户订单号
  platform?: string // 下单平台
  price?: string // 下单金额
  title?: string // 发票抬头
  type?: string // 发票类型
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
}
/**
 * 获取开票申请列表
 * @param params
 * @returns
 */
export const GET_INVOICABLE_PAGE = (params: InvoicePageParam) =>
  GET<TableRes<InvoicePageRes>>(`${HTTP}/order/getOrderInvoicablePage`, {
    ...params,
    supplierId: getSupplierId(),
  })

export type OrderInvoiceParams = {
  address: string // 地址
  bankAccount: string // 银行账号
  bankName: string // 开户银行
  content: string // 票面描述
  mobile: string // 电话
  orderInvoiceEnums: string // 发票类型
  receiveAddress: string // 收件人地址
  receiveMan: string // 收件人
  receiveMobile: string // 收件人联系电话
  remark: string // 其它备注
  taxNumber: string // 税号
  title: string // 发票抬头
}
/**
 * 提交开票申请
 * @param params
 * @returns
 */
export const SUBMIT_ORDER_INVOICE = (
  params: { orderId: string; fileIdList?: string[] } & OrderInvoiceParams,
) =>
  POST(
    `${HTTP}/order/submitOrderInvoice`,
    { ...params, supplierId: getSupplierId() },
    'application/json',
  )

// 获取发票申请详情
export const GET_ORDER_INVOICE_DETAIL = (params: { orderInvoiceId: string }) =>
  GET(`${HTTP}/order/orderInvoiceApplyInfo`, params)

export interface OrderInvoicingParams {
  createTime?: string // 下单时间
  customer?: string // 客户名称
  invoicingState?: string // 开票状态
  logisticsNum?: string // 物流单号
  orderNo?: string // 客户订单号
  platform?: string // 下单平台
  price?: string // 下单金额
  title?: string // 发票抬头
  type?: string // 发票类型
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  supplierId?: string
}

// 获取开票申请订单
export const GET_ORDER_INVOICING_PAGE = (params: OrderInvoicingParams) =>
  GET(`${HTTP}/order/getOrderInvoicingRequisitionPage`, {
    ...params,
    supplierId: getSupplierId(),
  })

// 根据订单id下载发票
export const POST_DOWNLOAD_INVOICE_ZIP = (params: { orderId: string }) =>
  downFilePost(
    `${HTTP}/order/downloadInvoiceZipByOrderId?orderId=${params.orderId}`,
  )

// 根据开票类型获取对应的数量
export const GET_INVOICE_COUNT = (params: { type: string }) =>
  GET(`${HTTP}/order/getInvoiceCountByType`, {
    ...params,
    supplierId: getSupplierId(),
  })

export type SupplierCountRes = {
  cancellationOrderCount: number
  invoiceCount: number
  returnOrderCount: number
}

export const GET_SUPPLIER_COUNT = (params: {
  supplierOrderId: string // 采购单id
}) =>
  GET<SupplierCountRes>(
    `${HTTP}/supplierOrderReturn/getSupplierOrderCount`,
    params,
  )

export type AllowAccountRes = {
  titleOfTheContract?: string
  customer: string
  customerInvoice: string
  finalPrice: number
  id: string
  orderNo: string
  orderPrice: number
  orderState: string
  orderTime: number
  platform: string
  platformCode: string
  receiveMan: string
  returnState: string
  signVoucherState: string
  isDisabled: boolean // 是否为不可勾选
  type?: 'new' | 'origin'
  code?: string
}

export interface ReconcilableParams {
  accountStatus?: string
  customer?: string
  orderNo?: string
  pageNo?: number
  pageSize?: number
  platform?: string
  schemeid?: string
  excludeOrderIds?: string // 被排除的订单Id集合
  supplierOrderCode?: string
  receiveMan?: string
}

export const GET_ALLOW_ACCOUNT_PAGE = (params: ReconcilableParams) =>
  GET<TableRes<AllowAccountRes>>(`${HTTP}/input/invoice/order/page`, {
    ...params,
    supplierUserId: getUserId(),
  })

interface BatchAccountParam {
  id?: string // 对账单id，修改对账单时传入
  orderIds: string[]
  price: number | string
  remark?: string
}

export const BATCH_ACCOUNT = (params: BatchAccountParam) =>
  POST(
    `${HTTP}/supplier/invoice/batchAccount`,
    {
      ...params,
      userId: getUserId(),
      supplierId: getSupplierId(),
      supplierName: GetLocalStorage('HOME_DATA')?.enterpriseName,
    },
    'application/json',
  )

export type InvoiceParams = {
  fileIdList: string[]
  fileList: { baseUrl: string; id: string; name: string; url: string }[]
  invoiceCode: string
  invoiceNum: string
  invoiceTime: number
  logisticsCompany: string
  logisticsNum: string
  price: number
  invoiceId: string
}

export type AccountOpenInvoiceParam = {
  invoiceParams: InvoiceParams[]
  deletedIds?: string[]
  deletedFileIds?: string[]
  orderAccountId: string
  supplierId?: string
}
/**
 * 对账单开票
 * @param params
 * @returns
 */
export const ACCOUNT_OPEN_INVOICE = (params: AccountOpenInvoiceParam) =>
  POST(
    `${HTTP}/input/invoice/accountOpenInvoice`,
    {
      ...params,
      supplierId: getSupplierId(),
    },
    'application/json',
  )

// 批量获取订单详情
export const GET_BATCH_ORDER_DETAIL = (params: { orderId: string }) =>
  GET<OrderDteailRes[]>(`${HTTP}/order/batchOrderDetail`, params)

export interface BatchProductInfo extends ListDetail {
  orderNo: string
  orderId: string
}
// 批量获取订单详情明细表格数据
export const BATCH_GET_ORDER_PRODUCT_INFO = (params: { orderIds: string }) =>
  GET<BatchProductInfo[]>(`${HTTP}/order/batchGetOrderProductInfo`, params)

// 订单合并开票申请
export const POST_BATCH_SUBMIT_ORDER_INVOICE = (
  params: {
    orderIds: string[]
    orderInvoiceFileDTOS?: {
      uploadMan: string
      url: string
    }[]
  } & OrderInvoiceParams,
) =>
  POST(
    `${HTTP}/order/batchSubmitOrderInvoice`,
    { ...params, supplierId: getSupplierId() },
    'application/json',
  )

// 根据开票申请单号获取关联订单详情
export const GET_ORDER_DETAIL_BY_APPLICATION_NUM = (params: {
  applicationNumber: string
}) =>
  GET<OrderDteailRes[]>(`${HTTP}/order/orderDetailsByApplicationNum`, params)

export type OverdueFeedbackUploadedFile = {
  name: string
  url: string
  baseUrl?: string
}

export const UPLOAD_FILES_NO_SAVE = (
  params: {
    type?: CertificateType
    code?: string
  },
  file: any,
) =>
  uploadFilePOST(`${HTTP}/upload/uploadFilesNoSave`, file, {
    ...params,
    uploadMan: GetLocalStorage('USER_NAME'),
  })

export const UPLOAD_OVERDUE_FEEDBACK_FILE = (
  params: { code?: string },
  file: RcFile,
) =>
  UPLOAD_FILES_NO_SAVE(
    { ...params, type: 'orderOverdueFeedback' },
    file,
  ) as Promise<ResultState<OverdueFeedbackUploadedFile[]>>

export type OverdueFeedbackSubmitParam = {
  orderId: string
  feedbackType: '1' | '2'
  expectFinishTime: string
  reason: string
  attachments: Array<{ name: string; url: string }>
}

export const SUBMIT_OVERDUE_FEEDBACK = (params: OverdueFeedbackSubmitParam) =>
  POST<boolean>(
    `${HTTP}/order/submitOverdueFeedback`,
    params,
    'application/json',
  )

export type InvoiceInfoRes = {
  bankAccount: string
  bankName: string
  invoiceAddress: string
  invoiceFaceInfo: string
  invoiceTitle: string
  invoiceType: string
  invoiceTypeStr: string
  mobile: string
  openInvoiceMobile: string
  receiveAddress: string
  receiveMan: string
  taxCode: string
}

export type InvoiceInfoParam = {
  orderId: string
}
/**
 * 根据订单 id 获取详情发票信息
 * @param params
 * @returns
 */
export const GET_INVOICE_INFO_BY_ID = (params: InvoiceInfoParam) =>
  GET<InvoiceInfoRes>(`${HTTP}/order/getOrderDetailInvoiceByOrderId`, params)

export interface RecognizeInvoiceParams {
  url: string
  fileId?: string
}

export interface RecognizeInvoiceRes {
  baseUrl: string
  invoiceCode: string
  invoiceNum: string
  invoiceTime: string
  totalAmount: string
  totalAmountIncludingTax: string
  totalTaxAmount: string
  url: string
  fileId: string
  invoiceType: {
    descriptions: string
    key: string
  }
  checkCode: string
}

// 批量获取发票代码和发票号
export const POST_RECOGNIZE_INVOICE = (params: { fileUrls: string }) =>
  GET<RecognizeInvoiceRes[]>(`${HTTP}/input/invoice/identify`, params)

// 导出寄票随单
export const POST_DOWNLOAD_ACCOUNT_ACCEPT_TEMP = (params: string[]) =>
  downFilePost(`${HTTP}/input/invoice/downloadAcceptTemp`, params)

// 获取工作台-开票付款数据
export const GET_ACCOUNT_PAYMENT_COUNT = (params: { supplierId: string }) =>
  GET(`${HTTP}/input/invoice/data-count`, params)

/**
 * 导出选中货物配货单
 * @returns
 */
export const EXPORT_SELECT_ORDER_DETAIL = (params: {
  directShipment: boolean
  orderId: string
  customerOrderCodes: any
  productCodeList: string[]
  ids: string[]
}) => downFilePost(`${HTTP}/supplierOrder/exportPackingList`, params)

export interface InvoiceEntryParams {
  customer?: string
  excludeOrderIds?: string // 被排除的订单Id集合
  orderNo?: string
  orderTimeStart?: string
  orderTimeEnd?: string
  pageNo?: number
  pageSize?: number
  platform?: string
  receiveMan?: string
  schemeId?: string
  signVoucher?: string
  customerPayback?: string
}

// 新增发票-分页获取电商供应商可开票订单
export const GET_INVOICE_PAYMENT_CANINVOICE = (params: InvoiceEntryParams) =>
  GET(`${HTTP}/input/invoice/order/page`, {
    ...params,
    supplierUserId: getUserId(),
  })

export interface InvoiceVerificationParams {
  invoiceCode: string // 发票代码
  invoiceNum: string // 发票号
  invoiceTime: number // 开票时间
  invoiceType: string // 发票类型
  totalAmount: number // 合计金额
  totalAmountIncludingTax: number // 价税合计
  totalTaxAmount: number // 合计税额
  relationId?: string // 发票单id
  checkCode?: string // 校验码
}

// 发票验真接口
export const INVOICE_VERIFICATION = (params: InvoiceVerificationParams) =>
  POST(`${HTTP}/input/invoice/verification`, params, 'application/json')

export interface InvoiceParamItem {
  file: {
    baseUrl: string
    id: string
    name: string
    url: string
  }
  id: string
  invoiceCode: string
  invoiceNum: string
  invoiceTime: number
  invoiceType: string
  totalAmount: number
  totalAmountIncludingTax: number
  totalTaxAmount: number
  seller?: string
}
export interface saveInvoiceParams {
  relationId: string
  dateState: string // 发票单状态
  deleteInvoiceIds?: string[] // 已删除的发票id
  deleteOrderIds?: string[] // 已删除的订单id
  invoiceParam: InvoiceParamItem[] // 发票列表数据
  orderIds: string[] // 订单id
  supplierId: string
  logisticsCompany: string
  logisticsNum: string
  deleteFileIds?: string[] // 已删除的发票附件id
}

// 保存或暂存电商供应商发票
export const LANDER_SAVE_INVOICE = (params: saveInvoiceParams) =>
  POST(`${HTTP}/input/invoice`, params, 'application/json')

// 保存或暂存供应商发票
export const SUPPLIER_SAVE_INVOICE = (params: saveInvoiceParams) =>
  POST(`${HTTP}/input/invoice/supplierInvoice`, params, 'application/json')

// 我的发票列表数据
export interface MyInvoiceItem {
  titleOfTheContract: any
  id: string
  accountId: string // 旧订单id
  invoiceAmount: number // 发票价税合计
  invoiceNums: string // 发票编号
  invoiceState: string // 1 审核中 2 暂存 3 通过 4 驳回
  orderAmount: number // 订单价税合计
  orderNos: string // 订单编号
  platform: string // 下单平台
  orderCodes: string // 采购订单号
  orderSource: string // 源单类型
  invoiceNature: string
}

/**
 * 分页获取我的发票
 * @param params
 * @returns
 */
export const GET_MY_INVOICE_LIST = (params: {
  schemeId?: string
  pageNo?: number
  pageSize?: number
  invoiceNum?: string
  orderNo?: string
  platform?: string
  invoiceState?: string
  orderSource?: string
  supplierOrderCode?: string
  invoiceNature?: string
  returnOrderNo?: string
}) =>
  GET<TableRes<MyInvoiceItem>>(`${HTTP}/input/invoice/relation/page`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

interface orderItem {
  orderTime: number // 下单时间
  customer: string // 客户名称
  customerReturnProgress: string // 回款进度 0-未回款 1-部分回款 2-全部回款
  id: string // 订单id
  orderNo: string // 客户订单号
  platform: string // 下单平台
  signVoucherState: string // 签收凭证
  totalAmount: number // 合计金额
  totalAmountIncludingTax: number // 价税合计
  totalTaxAmount: number // 合计税额
}

/**
 * ReturnOrderDetailVo
 */
export interface ReturnOrderDetailVo {
  /**
   * ERP 采购退料单号
   */
  erpNo?: string
  /**
   * 采购订单号
   */
  erpOrderNo?: string
  /**
   * 订单所属ERP
   */
  erpType?: string
  /**
   * 规格型号
   */
  model?: string
  /**
   * 客户订单号id
   */
  orderId?: string
  /**
   * 客户订单号
   */
  orderNo?: string
  /**
   * 单价
   */
  price?: number
  /**
   * 物料编码
   */
  productCode?: string
  /**
   * 退货单采购订单号
   */
  purchaseOrderNo?: string
  /**
   * 退货数量
   */
  returnNum?: number
  /**
   * 退货单明细id
   */
  returnOrderDetailId?: string
  /**
   * 退货单id
   */
  returnOrderId?: string
  /**
   * 退货单编号
   */
  returnOrderNo?: string
  /**
   * 税率
   */
  taxRate?: number
  /**
   * 合计金额
   */
  totalAmount?: number
  /**
   * 价税合计
   */
  totalAmountIncludingTax?: number
  /**
   * 合计税额
   */
  totalTaxAmount?: number
  titleOfTheContract: string
  returnTime: number
  [property: string]: any
}

export interface LanderInvoiceDetailData {
  dataState: string
  invoiceTotalAmountIncludingTax: string
  orderTotalAmountIncludingTax: string
  rejection: string
  orders: orderItem[]
  invoices: InvoiceParamItem[]
  logisticsCompany: string // 物流公司
  logisticsNum: string // 物流单号
  returnDetailList: ReturnOrderDetailVo[]
}

// 获取发票单详情-电商供应商订单
export const GET_INVOICE_DETAIL_DATA = (params: { relationDataId: string }) =>
  GET<LanderInvoiceDetailData>(`${HTTP}/input/invoice/relation/details`, params)

// 发票单-供应商订单明细
export interface SupplierOrderItem {
  code: string // 采购单号
  createTime: number // 创建时间
  finalPrice: number // 最终结算金额
  id: string // 订单id
  number: number // 结算件数
  receiveMan: string // 收件人
}
export interface SupplierInvoiceDetailData {
  dataState: string
  invoiceTotalAmountIncludingTax: string
  orderTotalAmountIncludingTax: string
  rejection: string
  orders: SupplierOrderItem[]
  invoices: InvoiceParamItem[]
  logisticsCompany: string // 物流公司
  logisticsNum: string // 物流单号
}

// 获取发票单详情-供应商订单
export const GET_SUPPLIER_INVOICE_DETAIL_DATA = (params: {
  relationDataId: string
}) =>
  GET<SupplierInvoiceDetailData>(
    `${HTTP}/input/invoice/relation/supplier/invoice/details`,
    params,
  )

// 获取已验真发票的数据
export const GET_VERIFICATION_RESULT = (params: InvoiceVerificationParams) =>
  POST(`${HTTP}/input/invoice/verification-result`, params, 'application/json')

// 获取已验真发票的数据 - 改为GET
export const GET_VERIFICATION_RESULT_DATA = (params: { invoiceNum: string }) =>
  GET(`${HTTP}/input/invoice/ocr-recognition-result`, params)

// 删除暂存的发票
export const DELETE_INVOICE_ITEM = (params: { invoiceOrderId: string }) =>
  DELETE(`${HTTP}/input/invoice`, params, 'multipart/form-data')

// 发票录入页-电商供应商订单明细导出
export const DOWNLOAD_INVOICE_ACCEPT_TEMP = (params: { orderIds: string }) =>
  downFileGET(`${HTTP}/input/invoice/exportDetail`, params)

// 保存发票录入页物流信息
export const SAVE_INVOICE_LOGISTICS = (params: {
  logisticsCompany: string // 物流公司
  logisticsNum: string // 物流单号
  invoiceOrderId: string
}) => POST(`${HTTP}/input/invoice/logistics`, params, 'application/json')

// 物流轨迹
export interface LogisticsInformation {
  AcceptStation: string
  AcceptTime: string
  accept_address: string
  opcode: string
}

// 获取发货单物流轨迹
export const GET_LOGISTICS_INFORMATION = (params: {
  expressCode: string // 物流公司编码
  expressNo: string // 物流单号
  id: string // 发货单id
  phoneNumber: string // 联系方式
}) =>
  POST<LogisticsInformation[]>(
    `${HTTP}/supplierOrder/getLogisticsInformation`,
    params,
    'application/json',
  )

// 下载订单附件
export const DOWNLOAD_ORDER_FILE = (params: {
  url: string
  fileName: string
}) => downFileGET(`${HTTP}/download/file`, params)

// 供应商订单拒单
export const REFUSE_SUPPLIER_ORDER = (params: {
  orderId: string // 订单id
  refuseReason: string // 拒单理由
  refuseOperatorId: string // 拒单操作人id
}) => GET(`${HTTP}/supplierOrder/refuseOrder`, params)

interface SupplierInvoiceEntryParams {
  supplierOrderCode?: string // 采购订单号
  pageNo?: number
  pageSize?: number
  receiveMan?: string // 收件人
  schemeId?: string
  excludeOrderIds?: string
}
interface SupplierInvoiceOrder {
  code: string // 采购订单
  createTime: number // 下单时间
  finalPrice: number // 最终结算金额
  id: string
  number: number // 结算件数
  receiveMan: string // 收件人
}
// 分页获取供应商可开票列表
export const GET_INVOICE_SUPPLIER_ORDER_PAGE = (
  params: SupplierInvoiceEntryParams,
) =>
  GET<TableRes<SupplierInvoiceOrder>>(
    `${HTTP}/input/invoice/supplierOrder/page`,
    {
      ...params,
      supplierUserId: getUserId(),
      supplierId: getSupplierId(),
    },
  )

// 发票录入页-供应商明细导出
export const EXPORT_SUPPLIER_ORDER_DETAIL = (params: { orderIds: string }) =>
  downFileGET(`${HTTP}/input/invoice/exportSupplierOrderDetail`, params)

// 发票录入页-供应商订单导出寄票随单
export const DOWNLOAD_SUPPLIER_ORDER_ACCEPT_TEMP = (params: string[]) =>
  downFilePost(`${HTTP}/input/invoice/downloadSupplierOrderAcceptTemp`, params)

interface ProductUrlItem {
  pictureUrl: string
  productCode: string
}

// 批量获取商品图
export const BATCH_GET_PRODUCT_PICTURE = (params: { productCodes: string[] }) =>
  POST<ProductUrlItem[]>(
    `${HTTP}/order/batchGetProductPicture`,
    params,
    'application/json',
  )

// 上传合同
export const UPLOAD_ORDER_PURCHASE_CONTRACT = (orderId: string, file: RcFile) =>
  POST(
    `${HTTP}/order/uploadPurchaseContract?orderId=${orderId}`,
    { file },
    'multipart/form-data',
  )

export const UPLOAD_ORDER_DESCRIPTION = (orderId: string, file: RcFile) =>
  POST(
    `${HTTP}/order/uploadOrderDescription?`,
    { orderId, file },
    'multipart/form-data',
  )

export const GET_ORDER_DESCRIPTION = (orderId: string) =>
  GET(
    `${HTTP}/order/getOrderDescriptionDetail`,
    { orderId },
    'application/json',
  )

export const ADD_ORDER_DESCRIPTION = (params: {
  orderDescriptionTextField: string
  orderId: string
  orderDescriptionFileList: string[]
}) =>
  POST(`${HTTP}/order/addOrUpdateOrderDescription`, params, 'application/json')

// 红票录入相关接口类型定义
export interface RedInvoiceReturnDetail {
  /**
   * 品牌
   */
  brand?: string
  /**
   * 发货明细id
   */
  deliveryDetailId?: string
  /**
   * 规格型号
   */
  manuCode?: string
  /**
   * 物料编码
   */
  productCode?: string
  /**
   * 商品名称
   */
  productName?: string
  /**
   * 单价（含税）
   */
  productPrice?: number
  /**
   * 退货数量
   */
  returnNum?: number
  /**
   * 税率
   */
  taxRate?: number
  /**
   * 合计金额（不含税金额）
   */
  totalAmount?: number
  /**
   * 价税合计（含税总金额）
   */
  totalAmountIncludingTax?: number
  /**
   * 合计税额
   */
  totalTaxAmount?: number
  /**
   * 单位
   */
  unit?: string
}

/**
 * 蓝票信息内部类
 *
 * BlueInvoiceInfo
 */
export interface BlueInvoiceInfo {
  /**
   * 对应的进项票id
   */
  inputInvoiceId?: string
  /**
   * 蓝票号码
   */
  invoiceNum?: string
  [property: string]: any
}

export interface RedInvoiceEntryItem {
  id: string // ID
  orderNo: string // 客户订单号
  /**
   * 客户订单已开蓝票信息列表
   */
  blueInvoiceInfos?: BlueInvoiceInfo[]
  // blueInvoiceNum: string // 客户订单已开蓝票号码
  returnNo: string // 退货单号
  customerName: string // 客户名称
  consignee: string // 收件人
  platform: string // 下单平台
  platformCode: string // 下单平台编码
  titleOfTheContract: string // 签约抬头
  titleOfTheContractName: string // 签约抬头名称
  returnTime: number // 退货时间（毫秒时间戳）
  taxRate: number // 税率
  returnAmount: number // 退货金额
  redInvoiceState: string // 红票状态
  redInvoiceStateName: string // 红票状态名称
  returnDetailList: RedInvoiceReturnDetail[] // 退货明细列表
}

export interface RedInvoiceEntryParams {
  supplierId?: string // 供应商ID（必填）
  schemeId?: string // 搜索方案ID
  userId?: string // 用户ID
  orderNo?: string // 客户订单号
  blueInvoiceNum?: string // 客户订单已开蓝票号码
  returnNo?: string // 退货单号
  customerName?: string // 客户名称
  consignee?: string // 收件人
  platformCode?: string // 下单平台（多选用逗号分隔）
  titleOfTheContract?: string // 签约抬头
  returnStartTime?: number // 退货时间开始（毫秒时间戳）
  returnEndTime?: number // 退货时间结束（毫秒时间戳）
  pageNo?: number // 页码，默认1
  pageSize?: number // 每页大小，默认20
}

// 分页获取红票录入列表
export const GET_RED_INVOICE_ENTRY_PAGE = (params: RedInvoiceEntryParams) =>
  GET<TableRes<RedInvoiceEntryItem>>(`${HTTP}/input/invoice/red`, {
    ...params,
    supplierId: getSupplierId(),
    userId: getUserId(),
  })

// 红票录入保存相关类型定义
export interface FileDTO {
  id?: string // id
  name?: string // 附件名
  url?: string // 附件路径
  baseUrl?: string // 前缀路径
  type?: string // 文件类型
}

export interface RedInvoiceParam {
  id?: string // id，修改时传入
  invoiceType: string // 发票类型 {@link com.xhgj.srm.common.enums.InvoiceTypeEnum}
  invoiceNum: string // 发票号码
  invoiceCode?: string // 发票代码
  invoiceTime: number // 开票时间（毫秒时间戳）
  totalAmount: number // 合计金额
  totalTaxAmount?: number // 合计税额
  totalAmountIncludingTax: number // 价税合计
  file?: FileDTO // 发票附件
  verificationType?: string // 验真类型
  relationId?: string // 关联数据id
  checkCode?: string // 校验码
  seller?: string // 销方
}

export interface RedInvoiceEntrySaveParam {
  relationId?: string // 红票 进项票ID（编辑时传入）
  returnOrderIds: string[] // 退货单ID列表
  invoiceParams: RedInvoiceParam[] // 红票发票信息列表
  supplierId?: string // 供应商ID
  userId?: string // 操作人ID
  isDraft?: boolean // 是否暂存（true-暂存，false-提交），默认true
}

/**
 * 红票录入保存
 * @param params 红票录入保存参数
 * @returns
 */
export const SAVE_RED_INVOICE_ENTRY = (params: RedInvoiceEntrySaveParam) =>
  POST(
    `${HTTP}/input/invoice/red`,
    {
      ...params,
      supplierId: getSupplierId(),
      userId: getUserId(),
    },
    'application/json',
  )

//  批量下载合同到压缩包
export const BATCH_DOWNLOAD_ZIP_THE_CONTRACT = (params: ExportZipParams) =>
  POST(`${HTTP}/order/batchDownloadZipTheContract`, params, 'application/json')

export interface TransferDispatchParam {
  orderId: string
  supplierId: string
  supplierName: string
  detailList: DetailParam[]
}

export interface DetailParam {
  /** 订单履约物料行id */
  detailId: string

  /** 转派数量（数量-退货-取消） */
  num: number
}

// 订单转派
export const POST_TRANSFER_DISPATCH = (params: TransferDispatchParam) =>
  POST(`${HTTP}/order/transferDispatch`, params, 'application/json')

/** /supplier/findBy 单条 */
export interface SupplierFindByDTO {
  id: string
  name: string
}

/** 按名称查询供应商（订单转派页搜索） */
export const GET_SUPPLIER_CAN_TRANSFER = (params: {
  name: string
  type: string
}) => GET(`${HTTP}/supplier/findBy`, params)
